var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo50D5C895(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4900,
    height: 1677.188,
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 1318 1677.188",
    xmlSpace: "preserve",
    stroke: "null",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("title", {
    stroke: "null"
  }, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.85,
    id: "svg_1",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path69404",
    d: "m710.116,1370.479c0,0 4.821,-136.952 122.479,-194.814c0,0 154.305,-25.076 163.952,-133.093c0,0 -55.634,104.008 -182.426,111.418c3.114,-0.856 4.973,-1.468 4.973,-1.468c40.506,-25.076 34.715,-102.23 34.715,-102.23c-1.93,-27.001 28.937,-65.58 28.937,-65.58c-32.797,5.786 -44.367,63.652 -44.367,63.652c-9.65,96.44 -82.431,107.268 -82.431,107.268c0.549,0.304 2.539,-0.613 3.117,-0.346c-18.044,-1.667 -37.172,-6.799 -46.057,-20.124c0,0 -21.223,-69.44 -3.857,-94.519c0,0 -21.218,-3.856 -25.08,52.08c0,0 7.393,66.746 -25.074,76.601c-32.467,-9.854 -25.072,-76.601 -25.072,-76.601c-3.857,-55.936 -25.076,-52.08 -25.076,-52.08c17.36,25.078 -3.858,94.519 -3.858,94.519c-7.698,11.539 -23.075,16.935 -38.779,19.257c-4.119,-0.64 -71.461,-12.564 -80.806,-106.055c0,0 -11.576,-57.866 -44.367,-63.652c0,0 30.86,38.578 28.93,65.58c0,0 -5.786,77.154 34.72,102.23c0,0 2.246,0.746 5.932,1.727c-131.545,-4.042 -189.167,-111.678 -189.167,-111.678c9.642,108.017 163.952,133.093 163.952,133.093c117.658,57.861 122.483,194.814 122.483,194.814c2.9,228.56 -121.961,268.115 -121.961,268.115l171.144,-0.046l0,0.046l1.925,-0.02l1.948,0.02l0,-0.046l166.208,0.046c0,0 -119.927,-39.545 -117.031,-268.115",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_3",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m758.578,1147.999c0.133,0.013 0.267,0.027 0.401,0.039c-0.096,-0.044 -0.241,-0.048 -0.401,-0.039z",
    id: "svg_4",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_5",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_6",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 605.659,
    y: 221.314,
    width: 13.164,
    height: 23.273,
    id: "svg_7",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "631.805,259.238 615.716,244.587 615.716,221.685 631.805,206.665 635.496,232.951     ",
    id: "svg_8",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m631.805,206.665c0,0 3.691,13.202 3.691,26.287c0,13.085 -3.691,26.286 -3.691,26.286",
    id: "svg_9",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m664.926,263.175l-5.448,-2.79c0.064,-0.124 6.525,-12.854 6.525,-28.365c0,-15.406 -7.475,-28.073 -7.551,-28.199l5.26,-3.128c0.344,0.571 8.419,14.182 8.419,31.327c0,17.04 -6.911,30.587 -7.205,31.155z",
    id: "svg_10",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m654.959,255.875l-5.448,-2.79c0.045,-0.088 4.754,-9.385 4.754,-20.69c0,-11.27 -5.435,-20.427 -5.49,-20.518l5.258,-3.131c0.26,0.431 6.361,10.713 6.361,23.65c-0.001,12.832 -5.213,23.051 -5.435,23.479z",
    id: "svg_11",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m645.534,247.872l-5.448,-2.79c0.026,-0.05 2.908,-5.766 2.908,-12.687c0,-6.816 -3.313,-12.467 -3.347,-12.523l5.262,-3.125c0.172,0.286 4.213,7.097 4.213,15.648c0.001,8.447 -3.441,15.194 -3.588,15.477z",
    id: "svg_12",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_13",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.457,
    y: 674.318,
    width: 13.164,
    height: 23.273,
    id: "svg_14",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.603,712.242 305.515,697.591 305.515,674.689 321.603,659.669 325.294,685.955     ",
    id: "svg_15",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.603,659.669c0,0 3.691,13.202 3.691,26.287c0,13.085 -3.691,26.286 -3.691,26.286",
    id: "svg_16",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.724,716.179l-5.448,-2.79c0.064,-0.124 6.525,-12.854 6.525,-28.365c0,-15.406 -7.475,-28.073 -7.551,-28.199l5.26,-3.128c0.344,0.571 8.419,14.182 8.419,31.327c0,17.04 -6.91,30.587 -7.205,31.155z",
    id: "svg_17",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.757,708.878l-5.448,-2.79c0.045,-0.088 4.754,-9.385 4.754,-20.69c0,-11.27 -5.435,-20.427 -5.49,-20.518l5.258,-3.131c0.26,0.431 6.361,10.713 6.361,23.65c-0.001,12.833 -5.213,23.052 -5.435,23.479z",
    id: "svg_18",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.333,700.876l-5.448,-2.79c0.026,-0.05 2.908,-5.766 2.908,-12.687c0,-6.816 -3.313,-12.467 -3.347,-12.523l5.262,-3.125c0.172,0.286 4.213,7.097 4.213,15.648c0,8.447 -3.441,15.193 -3.588,15.477z",
    id: "svg_19",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_20",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1097.237,
    y: 954.092,
    width: 13.164,
    height: 23.273,
    id: "svg_21",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1123.383,992.015 1107.294,977.364 1107.294,954.462 1123.383,939.442 1127.074,965.729     ",
    id: "svg_22",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1123.383,939.442c0,0 3.691,13.202 3.691,26.287s-3.691,26.286 -3.691,26.286",
    id: "svg_23",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1156.504,995.952l-5.448,-2.79c0.063,-0.124 6.525,-12.854 6.525,-28.365c0,-15.406 -7.475,-28.073 -7.551,-28.199l5.26,-3.128c0.344,0.571 8.419,14.182 8.419,31.327c0,17.04 -6.911,30.588 -7.205,31.155z",
    id: "svg_24",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1146.537,988.652l-5.448,-2.79c0.045,-0.088 4.754,-9.385 4.754,-20.69c0,-11.27 -5.435,-20.427 -5.49,-20.518l5.258,-3.131c0.26,0.431 6.361,10.713 6.361,23.65c-0.001,12.833 -5.213,23.051 -5.435,23.479z",
    id: "svg_25",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1137.112,980.649l-5.448,-2.79c0.026,-0.05 2.908,-5.766 2.908,-12.687c0,-6.816 -3.313,-12.467 -3.347,-12.523l5.262,-3.125c0.172,0.286 4.213,7.097 4.213,15.648c0.001,8.447 -3.441,15.194 -3.588,15.477z",
    id: "svg_26",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_27",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.836,
    y: 820.02,
    width: 13.164,
    height: 23.273,
    id: "svg_28",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.982,857.943 400.893,843.293 400.893,820.39 416.982,805.37 420.673,831.657     ",
    id: "svg_29",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.982,805.37c0,0 3.691,13.202 3.691,26.287s-3.691,26.286 -3.691,26.286",
    id: "svg_30",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.103,861.88l-5.448,-2.79c0.064,-0.124 6.525,-12.854 6.525,-28.365c0,-15.406 -7.475,-28.073 -7.551,-28.199l5.26,-3.128c0.344,0.571 8.419,14.182 8.419,31.327c0,17.04 -6.911,30.588 -7.205,31.155z",
    id: "svg_31",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.136,854.58l-5.448,-2.79c0.045,-0.088 4.754,-9.385 4.754,-20.69c0,-11.27 -5.435,-20.427 -5.49,-20.518l5.258,-3.131c0.26,0.431 6.361,10.713 6.361,23.65c-0.001,12.833 -5.213,23.051 -5.435,23.479z",
    id: "svg_32",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.711,846.577l-5.448,-2.79c0.026,-0.05 2.908,-5.766 2.908,-12.687c0,-6.816 -3.313,-12.467 -3.347,-12.523l5.262,-3.125c0.172,0.286 4.213,7.097 4.213,15.648c0.001,8.447 -3.441,15.194 -3.588,15.477z",
    id: "svg_33",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_34",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_35",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_36",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m809.103,347.095l-4.944,0c-3.409,0 -6.717,-2.494 -6.717,-6.83c0,0 0,-31.065 0,-31.144c0,-3.863 3.229,-6.787 6.717,-6.787l4.944,0l0,44.761l0,0z",
    id: "svg_37",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m840.265,302.412l0,-6.425c0,-2.335 -2.067,-3.817 -4.572,-3.817c0,0 -9.635,0 -9.603,0c-2.505,0 -4.607,1.482 -4.607,3.817l0,6.425l-7.823,0l0,44.761l34.507,0l0,-44.761l-7.902,0zm-4.599,0l-9.699,0l0,-6.038l9.699,0l0,6.038z",
    id: "svg_38",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_39",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m852.643,347.095l4.944,0c3.409,0 6.717,-2.494 6.717,-6.83c0,0 0,-31.065 0,-31.144c0,-3.863 -3.229,-6.787 -6.717,-6.787l-4.944,0l0,44.761z",
    id: "svg_40",
    fill: "#191a19",
    stroke: "null"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svg_41",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_42",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_43",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m541.535,245.468l-4.944,0c-3.409,0 -6.717,-2.494 -6.717,-6.83c0,0 0,-31.065 0,-31.144c0,-3.863 3.229,-6.787 6.717,-6.787l4.944,0l0,44.761l0,0z",
    id: "svg_44",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m572.697,200.785l0,-6.425c0,-2.335 -2.068,-3.817 -4.572,-3.817c0,0 -9.635,0 -9.603,0c-2.505,0 -4.607,1.482 -4.607,3.817l0,6.425l-7.823,0l0,44.761l34.507,0l0,-44.761l-7.902,0zm-4.599,0l-9.699,0l0,-6.038l9.699,0l0,6.038z",
    id: "svg_45",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_46",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m585.076,245.468l4.944,0c3.409,0 6.717,-2.494 6.717,-6.83c0,0 0,-31.065 0,-31.144c0,-3.863 -3.229,-6.787 -6.717,-6.787l-4.944,0l0,44.761z",
    id: "svg_47",
    fill: "#191a19",
    stroke: "null"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svg_48",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_49",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_50",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m878.935,221.105l-4.944,0c-3.409,0 -6.717,-2.494 -6.717,-6.83c0,0 0,-31.065 0,-31.144c0,-3.863 3.229,-6.787 6.717,-6.787l4.944,0l0,44.761l0,0z",
    id: "svg_51",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m910.097,176.422l0,-6.425c0,-2.335 -2.068,-3.817 -4.572,-3.817c0,0 -9.635,0 -9.603,0c-2.505,0 -4.607,1.482 -4.607,3.817l0,6.425l-7.823,0l0,44.761l34.507,0l0,-44.761l-7.902,0zm-4.598,0l-9.699,0l0,-6.038l9.699,0l0,6.038z",
    id: "svg_52",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_53",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m922.476,221.105l4.944,0c3.409,0 6.717,-2.494 6.717,-6.83c0,0 0,-31.065 0,-31.144c0,-3.863 -3.229,-6.787 -6.717,-6.787l-4.944,0l0,44.761z",
    id: "svg_54",
    fill: "#191a19",
    stroke: "null"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svg_55",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_56",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_57",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1105.476,647.008l-4.944,0c-3.409,0 -6.717,-2.494 -6.717,-6.83c0,0 0,-31.065 0,-31.144c0,-3.863 3.229,-6.787 6.717,-6.787l4.944,0l0,44.761l0,0z",
    id: "svg_58",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1136.638,602.325l0,-6.425c0,-2.335 -2.068,-3.818 -4.572,-3.818c0,0 -9.635,0 -9.603,0c-2.505,0 -4.608,1.482 -4.608,3.818l0,6.425l-7.823,0l0,44.761l34.507,0l0,-44.761l-7.901,0zm-4.599,0l-9.699,0l0,-6.038l9.699,0l0,6.038z",
    id: "svg_59",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_60",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1149.016,647.008l4.944,0c3.408,0 6.717,-2.494 6.717,-6.83c0,0 0,-31.065 0,-31.144c0,-3.863 -3.229,-6.787 -6.717,-6.787l-4.944,0l0,44.761z",
    id: "svg_61",
    fill: "#191a19",
    stroke: "null"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svg_62",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.086,
    y: 808.862,
    width: 14.089,
    height: 37.897,
    id: "svg_63",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.086,
    y: 853.124,
    width: 14.089,
    height: 11.152,
    id: "svg_64",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_65",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.078,
    y: 808.325,
    width: 14.089,
    height: 37.897,
    id: "svg_66",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.078,
    y: 852.587,
    width: 14.089,
    height: 11.152,
    id: "svg_67",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_68",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1267.151,
    y: 623.949,
    width: 14.089,
    height: 37.897,
    id: "svg_69",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1267.151,
    y: 668.211,
    width: 14.089,
    height: 11.152,
    id: "svg_70",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_71",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 870.702,
    y: 1010.03,
    width: 14.089,
    height: 37.897,
    id: "svg_72",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.702,
    y: 1054.292,
    width: 14.089,
    height: 11.152,
    id: "svg_73",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_74",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "125.628,911.887 92.742,955.422 100.325,924.8 82.683,925.096 89.889,889.092 111.287,889.092 102.697,911.906           ",
    id: "svg_75",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_76",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "365.764,236.343 332.878,279.878 340.46,249.256 322.819,249.552 330.025,213.548 351.422,213.548       342.833,236.362     ",
    id: "svg_77",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_78",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1287.671,585.811 1254.785,629.346 1262.368,598.724 1244.726,599.02 1251.932,563.016 1273.33,563.016       1264.74,585.83     ",
    id: "svg_79",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_80",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "819.401,1087.292 786.515,1130.828 794.097,1100.206 776.456,1100.502 783.662,1064.498 805.06,1064.498       796.47,1087.312     ",
    id: "svg_81",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_82",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m709.051,578.677c0,0 -4.387,-6.363 -15.565,-6.363c-10.241,-0.001 -15.564,2.96 -15.564,2.96l0,-41.13c0,0 5.324,-2.96 15.565,-3.029c11.177,-0.075 15.564,6.431 15.564,6.431l0,41.131z",
    id: "svg_83",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m713.592,578.677c0,0 4.387,-6.363 15.565,-6.363c10.241,0 15.565,2.961 15.565,2.961l0,-41.131c0,0 -5.324,-2.96 -15.565,-3.029c-11.178,-0.075 -15.565,6.431 -15.565,6.431l0,41.131z",
    id: "svg_84",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m711.4,591.483c0,0 -6.736,-9.656 -17.913,-9.656c-10.241,0 -15.565,2.961 -15.565,2.961l0,-4.928c0,0 5.324,-2.96 15.565,-3.029c11.177,-0.075 17.913,9.724 17.913,9.724l0,4.928z",
    id: "svg_85",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m711.4,591.483c0,0 6.736,-9.656 17.913,-9.656c10.241,0 15.565,2.961 15.565,2.961l0,-4.928c0,0 -5.324,-2.96 -15.565,-3.029c-11.177,-0.075 -17.913,9.724 -17.913,9.724l0,4.928z",
    id: "svg_86",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_87",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m1214.241,509.021c0,0 -4.387,-6.363 -15.565,-6.363c-10.241,-0.001 -15.564,2.96 -15.564,2.96l0,-41.13c0,0 5.324,-2.96 15.565,-3.029c11.177,-0.075 15.564,6.431 15.564,6.431l0,41.131z",
    id: "svg_88",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m1218.783,509.021c0,0 4.387,-6.363 15.565,-6.363c10.241,0 15.565,2.961 15.565,2.961l0,-41.131c0,0 -5.324,-2.96 -15.565,-3.029c-11.178,-0.075 -15.565,6.431 -15.565,6.431l0,41.131z",
    id: "svg_89",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m1216.59,521.827c0,0 -6.736,-9.656 -17.913,-9.656c-10.241,0 -15.565,2.961 -15.565,2.961l0,-4.928c0,0 5.324,-2.96 15.565,-3.029c11.177,-0.075 17.913,9.724 17.913,9.724l0,4.928z",
    id: "svg_90",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m1216.591,521.827c0,0 6.736,-9.656 17.913,-9.656c10.241,0 15.565,2.961 15.565,2.961l0,-4.928c0,0 -5.324,-2.96 -15.565,-3.029c-11.177,-0.075 -17.913,9.724 -17.913,9.724l0,4.928z",
    id: "svg_91",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_92",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m580.04,107.691c0,0 -4.387,-6.363 -15.565,-6.363c-10.24,-0.001 -15.564,2.96 -15.564,2.96l0,-41.13c0,0 5.324,-2.96 15.565,-3.029c11.177,-0.075 15.564,6.431 15.564,6.431l0,41.131z",
    id: "svg_93",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m584.581,107.691c0,0 4.387,-6.363 15.565,-6.363c10.241,0 15.565,2.961 15.565,2.961l0,-41.131c0,0 -5.324,-2.96 -15.565,-3.029c-11.178,-0.075 -15.565,6.431 -15.565,6.431l0,41.131z",
    id: "svg_94",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m582.389,120.497c0,0 -6.736,-9.656 -17.913,-9.656c-10.241,0 -15.565,2.961 -15.565,2.961l0,-4.928c0,0 5.324,-2.96 15.565,-3.029c11.177,-0.075 17.913,9.724 17.913,9.724l0,4.928z",
    id: "svg_95",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m582.39,120.497c0,0 6.736,-9.656 17.913,-9.656c10.241,0 15.565,2.961 15.565,2.961l0,-4.928c0,0 -5.324,-2.96 -15.565,-3.029c-11.177,-0.075 -17.913,9.724 -17.913,9.724l0,4.928z",
    id: "svg_96",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_97",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m1000.241,1039.559c0,0 -4.387,-6.363 -15.565,-6.363c-10.241,0 -15.564,2.96 -15.564,2.96l0,-41.13c0,0 5.324,-2.96 15.565,-3.029c11.177,-0.075 15.564,6.431 15.564,6.431l0,41.131z",
    id: "svg_98",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m1004.782,1039.559c0,0 4.387,-6.363 15.565,-6.363c10.241,0 15.565,2.961 15.565,2.961l0,-41.131c0,0 -5.324,-2.96 -15.565,-3.029c-11.178,-0.075 -15.565,6.431 -15.565,6.431l0,41.131z",
    id: "svg_99",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m1002.59,1052.365c0,0 -6.736,-9.656 -17.913,-9.656c-10.241,0 -15.565,2.961 -15.565,2.961l0,-4.928c0,0 5.324,-2.96 15.565,-3.029c11.177,-0.075 17.913,9.724 17.913,9.724l0,4.928z",
    id: "svg_100",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m1002.591,1052.365c0,0 6.736,-9.656 17.913,-9.656c10.241,0 15.565,2.961 15.565,2.961l0,-4.928c0,0 -5.324,-2.96 -15.565,-3.029c-11.177,-0.075 -17.913,9.724 -17.913,9.724l0,4.928z",
    id: "svg_101",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_102",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 520.735,
    y: 767.805,
    width: 64.627,
    height: 6.594,
    id: "svg_103",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.378,
    y: 761.423,
    width: 58.487,
    height: 3.626,
    id: "svg_104",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.138,
    y: 729.255,
    width: 9.827,
    height: 29.328,
    id: "svg_105",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 547.747,
    y: 729.255,
    width: 9.827,
    height: 29.328,
    id: "svg_106",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 566.603,
    y: 729.255,
    width: 9.827,
    height: 29.328,
    id: "svg_107",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.621,722.842 553.049,707.902 586.476,722.842 586.446,726.694 519.621,726.748     ",
    id: "svg_108",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_109",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.862,
    y: 440.825,
    width: 64.627,
    height: 6.594,
    id: "svg_110",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.505,
    y: 434.443,
    width: 58.487,
    height: 3.626,
    id: "svg_111",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.265,
    y: 402.275,
    width: 9.827,
    height: 29.328,
    id: "svg_112",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.874,
    y: 402.275,
    width: 9.827,
    height: 29.328,
    id: "svg_113",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.73,
    y: 402.275,
    width: 9.827,
    height: 29.328,
    id: "svg_114",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.748,395.862 208.175,380.922 241.603,395.862 241.573,399.714 174.748,399.768     ",
    id: "svg_115",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_116",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 373.873,
    y: 563.228,
    width: 64.627,
    height: 6.594,
    id: "svg_117",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.516,
    y: 556.846,
    width: 58.487,
    height: 3.626,
    id: "svg_118",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.277,
    y: 524.678,
    width: 9.827,
    height: 29.328,
    id: "svg_119",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.885,
    y: 524.678,
    width: 9.827,
    height: 29.328,
    id: "svg_120",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.742,
    y: 524.678,
    width: 9.827,
    height: 29.328,
    id: "svg_121",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.759,518.265 406.187,503.326 439.614,518.265 439.584,522.118 372.759,522.172     ",
    id: "svg_122",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_123",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.796,
    y: 830.685,
    width: 64.627,
    height: 6.594,
    id: "svg_124",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.439,
    y: 824.303,
    width: 58.487,
    height: 3.626,
    id: "svg_125",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.199,
    y: 792.136,
    width: 9.827,
    height: 29.328,
    id: "svg_126",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.807,
    y: 792.136,
    width: 9.827,
    height: 29.328,
    id: "svg_127",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.664,
    y: 792.136,
    width: 9.827,
    height: 29.328,
    id: "svg_128",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.681,785.722 142.109,770.783 175.537,785.722 175.506,789.575 108.681,789.629     ",
    id: "svg_129",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_130",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m416.356,1179.333l0,60.955l53.806,0l0,-60.955l-53.806,0zm15.71,53.514l-9.106,0l0,-9.056l9.106,0l0,9.056zm0,-13.828l-9.106,0l0,-9.057l9.106,0l0,9.057zm15.746,13.828l-9.106,0l0,-9.056l9.106,0l0,9.056zm0,-13.828l-9.106,0l0,-9.057l9.106,0l0,9.057zm15.774,13.828l-9.107,0l0,-22.885l9.107,0l0,22.885l0,0zm0.335,-31.791l-40.866,0l0,-14.511l40.866,0c0,0 0,14.511 0,14.511z",
    id: "svg_131",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_132",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m560.444,996.129l0,60.955l53.806,0l0,-60.955l-53.806,0zm15.71,53.513l-9.106,0l0,-9.056l9.106,0l0,9.056zm0,-13.827l-9.106,0l0,-9.057l9.106,0l0,9.057zm15.746,13.827l-9.106,0l0,-9.056l9.106,0l0,9.056zm0,-13.827l-9.106,0l0,-9.057l9.106,0l0,9.057zm15.774,13.827l-9.107,0l0,-22.885l9.107,0l0,22.885l0,0zm0.335,-31.79l-40.866,0l0,-14.511l40.866,0c0,0 0,14.511 0,14.511z",
    id: "svg_133",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_134",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m227.797,983.204l0,60.955l53.806,0l0,-60.955l-53.806,0zm15.711,53.513l-9.106,0l0,-9.056l9.106,0l0,9.056zm0,-13.827l-9.106,0l0,-9.057l9.106,0l0,9.057zm15.746,13.827l-9.106,0l0,-9.056l9.106,0l0,9.056zm0,-13.827l-9.106,0l0,-9.057l9.106,0l0,9.057zm15.774,13.827l-9.107,0l0,-22.885l9.107,0l0,22.885l0,0zm0.334,-31.79l-40.866,0l0,-14.511l40.866,0c0,-0.001 0,14.511 0,14.511z",
    id: "svg_135",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_136",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m965.313,561.288l0,60.955l53.806,0l0,-60.955l-53.806,0zm15.711,53.514l-9.106,0l0,-9.056l9.106,0l0,9.056zm0,-13.828l-9.106,0l0,-9.057l9.106,0l0,9.057zm15.746,13.828l-9.106,0l0,-9.056l9.106,0l0,9.056zm0,-13.828l-9.106,0l0,-9.057l9.106,0l0,9.057zm15.774,13.828l-9.107,0l0,-22.885l9.107,0l0,22.885l0,0zm0.335,-31.791l-40.866,0l0,-14.511l40.866,0c0,0 0,14.511 0,14.511z",
    id: "svg_137",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_138",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_139",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m330.64,928.379c-6.59,0 -11.951,5.333 -11.951,11.887c0,6.554 5.361,11.887 11.951,11.887s11.951,-5.333 11.951,-11.887c0,-6.554 -5.362,-11.887 -11.951,-11.887z",
    id: "svg_140",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.514,918.096l-2.604,-7.945l-26.542,0l-2.604,7.945l-23.654,0l0,44.339l66.855,0l0,-44.339c0,0 -11.451,0 -11.451,0zm-39.76,12.07l-9.197,0l0,-4.887l9.197,0l0,4.887zm23.886,27.528c-9.662,0 -17.522,-7.818 -17.522,-17.428c0,-9.61 7.861,-17.428 17.522,-17.428s17.522,7.818 17.522,17.428c0,9.61 -7.861,17.428 -17.522,17.428z",
    id: "svg_141",
    fill: "#191a19",
    stroke: "null"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_142",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_143",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m260.767,706.884c-6.59,0 -11.951,5.332 -11.951,11.887s5.361,11.887 11.951,11.887c6.59,0 11.951,-5.332 11.951,-11.887s-5.362,-11.887 -11.951,-11.887z",
    id: "svg_144",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.641,696.601l-2.604,-7.945l-26.542,0l-2.604,7.945l-23.655,0l0,44.339l66.855,0l0,-44.339c0.001,0 -11.45,0 -11.45,0zm-39.76,12.07l-9.197,0l0,-4.887l9.197,0l0,4.887zm23.886,27.528c-9.662,0 -17.522,-7.818 -17.522,-17.428c0,-9.61 7.861,-17.428 17.522,-17.428s17.522,7.818 17.522,17.428c0,9.61 -7.861,17.428 -17.522,17.428z",
    id: "svg_145",
    fill: "#191a19",
    stroke: "null"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_146",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_147",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m950.904,513.721c-6.59,0 -11.951,5.333 -11.951,11.887c0,6.554 5.361,11.887 11.951,11.887c6.59,0 11.951,-5.333 11.951,-11.887c0,-6.554 -5.361,-11.887 -11.951,-11.887z",
    id: "svg_148",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m966.779,503.438l-2.604,-7.945l-26.542,0l-2.604,7.945l-23.655,0l0,44.339l66.855,0l0,-44.339c0.001,0 -11.45,0 -11.45,0zm-39.761,12.07l-9.197,0l0,-4.887l9.197,0l0,4.887zm23.886,27.528c-9.662,0 -17.522,-7.818 -17.522,-17.428c0,-9.61 7.861,-17.428 17.522,-17.428c9.662,0 17.522,7.818 17.522,17.428c0,9.61 -7.86,17.428 -17.522,17.428z",
    id: "svg_149",
    fill: "#191a19",
    stroke: "null"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_150",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_151",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m507.333,145.557c-6.59,0 -11.951,5.332 -11.951,11.887s5.361,11.887 11.951,11.887c6.59,0 11.951,-5.332 11.951,-11.887s-5.361,-11.887 -11.951,-11.887z",
    id: "svg_152",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m523.208,135.274l-2.604,-7.945l-26.542,0l-2.604,7.945l-23.655,0l0,44.339l66.855,0l0,-44.339c0.001,0 -11.45,0 -11.45,0zm-39.761,12.07l-9.197,0l0,-4.887l9.197,0l0,4.887zm23.886,27.528c-9.662,0 -17.522,-7.818 -17.522,-17.428c0,-9.61 7.861,-17.428 17.522,-17.428c9.662,0 17.522,7.818 17.522,17.428c0,9.61 -7.86,17.428 -17.522,17.428z",
    id: "svg_153",
    fill: "#191a19",
    stroke: "null"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_154",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m543.277,821.697l-5.529,-14.045c-1.041,-2.675 -3.296,-4.961 -7.546,-4.961l-7.81,0l-13.305,-0.001l-7.9,0c-4.25,0 -6.506,2.286 -7.546,4.961l-5.53,14.045c-2.19,0.277 -6.069,2.811 -6.069,7.607l0,17.87l5.377,0l0,5.706c0,7.029 10.103,6.946 10.103,0l0,-5.706l18.168,0l0.001,0l0.009,0l0.001,0l18.168,0l0,5.706c0,6.947 10.104,7.03 10.104,0l0,-5.706l5.377,0l0,-17.869c0,-4.796 -3.883,-7.33 -6.073,-7.607zm-50.646,14.553c-2.577,0 -4.666,-2.12 -4.666,-4.736c0,-2.617 2.089,-4.737 4.666,-4.737c2.577,0 4.667,2.121 4.667,4.737c-0.001,2.615 -2.09,4.736 -4.667,4.736zm23.069,-14.884l-0.011,0l-0.01,0l-21.845,0l4.163,-10.867c0.52,-1.553 1.301,-2.675 3.123,-2.691l14.559,0l0.01,0l0.011,0l14.566,0c1.822,0.017 2.602,1.139 3.122,2.691l4.163,10.867l-21.851,0zm23.055,14.884c-2.577,0 -4.667,-2.12 -4.667,-4.736c0,-2.617 2.09,-4.737 4.667,-4.737c2.578,0 4.667,2.121 4.667,4.737c0,2.615 -2.089,4.736 -4.667,4.736z",
    id: "svg_155",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_156",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1150.665,759.949l-5.529,-14.045c-1.041,-2.675 -3.296,-4.961 -7.546,-4.961l-7.81,0l-13.305,-0.001l-7.9,0c-4.25,0 -6.506,2.286 -7.546,4.961l-5.529,14.045c-2.19,0.277 -6.069,2.811 -6.069,7.607l0,17.87l5.377,0l0,5.706c0,7.029 10.103,6.946 10.103,0l0,-5.707l18.168,0l0.001,0l0.009,0l0,0l18.168,0l0,5.706c0,6.947 10.104,7.03 10.104,0l0,-5.706l5.377,0l0,-17.869c0,-4.795 -3.883,-7.33 -6.073,-7.606zm-50.646,14.552c-2.577,0 -4.667,-2.12 -4.667,-4.736c0,-2.617 2.089,-4.737 4.667,-4.737s4.667,2.121 4.667,4.737c-0.001,2.616 -2.09,4.736 -4.667,4.736zm23.069,-14.884l-0.011,0l-0.01,0l-21.845,0l4.163,-10.867c0.52,-1.553 1.302,-2.675 3.123,-2.691l14.559,0l0.01,0l0.011,0l14.566,0c1.822,0.017 2.602,1.139 3.122,2.691l4.163,10.867l-21.851,0zm23.055,14.884c-2.577,0 -4.667,-2.12 -4.667,-4.736c0,-2.617 2.09,-4.737 4.667,-4.737c2.578,0 4.667,2.121 4.667,4.737c0,2.616 -2.089,4.736 -4.667,4.736z",
    id: "svg_157",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_158",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m349.826,742.58l-5.53,-14.045c-1.041,-2.675 -3.296,-4.961 -7.546,-4.961l-7.81,0l-13.305,-0.001l-7.9,0c-4.25,0 -6.506,2.286 -7.546,4.961l-5.53,14.045c-2.19,0.276 -6.069,2.811 -6.069,7.607l0,17.87l5.377,0l0,5.706c0,7.029 10.103,6.946 10.103,0l0,-5.707l18.168,0l0.001,0l0.009,0l0.001,0l18.168,0l0,5.706c0,6.947 10.104,7.03 10.104,0l0,-5.706l5.377,0l0,-17.869c0.001,-4.795 -3.882,-7.33 -6.072,-7.606zm-50.646,14.552c-2.577,0 -4.667,-2.12 -4.667,-4.736c0,-2.617 2.089,-4.737 4.667,-4.737c2.577,0 4.666,2.121 4.666,4.737c0,2.616 -2.089,4.736 -4.666,4.736zm23.069,-14.884l-0.011,0l-0.01,0l-21.845,0l4.163,-10.867c0.52,-1.553 1.301,-2.675 3.123,-2.691l14.559,0l0.01,0l0.011,0l14.566,0c1.822,0.017 2.602,1.139 3.122,2.691l4.163,10.867l-21.851,0zm23.055,14.884c-2.577,0 -4.667,-2.12 -4.667,-4.736c0,-2.617 2.09,-4.737 4.667,-4.737c2.578,0 4.667,2.121 4.667,4.737c0,2.616 -2.089,4.736 -4.667,4.736z",
    id: "svg_159",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_160",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m621.499,813.082l-5.53,-14.045c-1.041,-2.675 -3.296,-4.961 -7.546,-4.961l-7.81,0l-13.305,-0.001l-7.9,0c-4.25,0 -6.506,2.286 -7.546,4.961l-5.53,14.045c-2.19,0.276 -6.069,2.811 -6.069,7.607l0,17.87l5.377,0l0,5.706c0,7.029 10.103,6.946 10.103,0l0,-5.707l18.168,0l0.001,0l0.009,0l0.001,0l18.168,0l0,5.706c0,6.947 10.104,7.03 10.104,0l0,-5.706l5.377,0l0,-17.867c0.001,-4.797 -3.881,-7.331 -6.072,-7.608zm-50.646,14.553c-2.577,0 -4.667,-2.12 -4.667,-4.736c0,-2.617 2.089,-4.737 4.667,-4.737s4.667,2.121 4.667,4.737c-0.001,2.615 -2.09,4.736 -4.667,4.736zm23.069,-14.884l-0.011,0l-0.01,0l-21.845,0l4.163,-10.867c0.52,-1.553 1.302,-2.675 3.123,-2.691l14.559,0l0.01,0l0.011,0l14.566,0c1.822,0.017 2.602,1.139 3.122,2.691l4.163,10.867l-21.851,0zm23.055,14.884c-2.577,0 -4.667,-2.12 -4.667,-4.736c0,-2.617 2.09,-4.737 4.667,-4.737c2.578,0 4.667,2.121 4.667,4.737c0,2.615 -2.089,4.736 -4.667,4.736z",
    id: "svg_161",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "485.68,927.07 474.68,916.128 440.313,950.311 423.754,933.836 413.441,944.091 441.033,971.542      451.346,961.287 451.312,961.253    ",
    id: "svg_162",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1237.831,932.159 1226.83,921.218 1192.464,955.401 1175.905,938.925 1165.592,949.18 1193.184,976.632      1203.497,966.377 1203.463,966.343    ",
    id: "svg_163",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.694,97.724 443.694,86.783 409.327,120.965 392.768,104.49 382.455,114.745 410.047,142.197 420.36,131.942      420.326,131.908    ",
    id: "svg_164",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "558.868,1043.033 547.867,1032.092 513.501,1066.274 496.942,1049.799 486.629,1060.054 514.221,1087.506      524.534,1077.251 524.5,1077.217    ",
    id: "svg_165",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_166",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 836.534,
    cy: 596.434,
    rx: 30.178,
    ry: 30.016,
    id: "svg_167",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_168",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.531,
    cy: 602.33,
    rx: 30.178,
    ry: 30.016,
    id: "svg_169",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_170",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 743.075,
    cy: 1039.403,
    rx: 30.178,
    ry: 30.016,
    id: "svg_171",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_172",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.116,
    cy: 538.199,
    rx: 30.178,
    ry: 30.016,
    id: "svg_173",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m936.071,921.859c0,-8.286 -6.093,-15.154 -14.066,-16.419c-2.148,-9.334 -10.543,-16.299 -20.578,-16.299c-11.342,0 -20.592,8.895 -21.092,20.054c-6.401,1.693 -11.119,7.496 -11.119,14.397c0,8.228 6.706,14.898 14.978,14.898c0.001,0 0.001,0 0.001,0l35.155,0c0.001,0 0.001,0 0.001,0l0.001,0l2.094,0l0,-0.135c8.245,-1.027 14.625,-8.018 14.625,-16.496z",
    id: "svg_174",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460.833,341.417c0,-8.286 -6.093,-15.154 -14.066,-16.419c-2.148,-9.334 -10.543,-16.299 -20.578,-16.299c-11.342,0 -20.592,8.895 -21.092,20.054c-6.401,1.693 -11.119,7.496 -11.119,14.397c0,8.228 6.706,14.898 14.978,14.898c0.001,0 0.001,0 0.001,0l35.155,0c0.001,0 0.001,0 0.001,0l0.001,0l2.094,0l0,-0.135c8.245,-1.026 14.625,-8.018 14.625,-16.496z",
    id: "svg_175",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1224.288,745.083c0,-8.286 -6.093,-15.154 -14.066,-16.419c-2.148,-9.334 -10.543,-16.299 -20.578,-16.299c-11.342,0 -20.592,8.895 -21.092,20.054c-6.401,1.693 -11.119,7.496 -11.119,14.397c0,8.228 6.706,14.898 14.978,14.898c0,0 0.001,0 0.001,0l35.155,0c0,0 0.001,0 0.001,0l0.001,0l2.094,0l0,-0.135c8.245,-1.027 14.625,-8.018 14.625,-16.496z",
    id: "svg_176",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1069.943,678.466c0,-8.286 -6.093,-15.154 -14.066,-16.419c-2.148,-9.334 -10.543,-16.299 -20.578,-16.299c-11.342,0 -20.592,8.895 -21.092,20.054c-6.401,1.693 -11.119,7.496 -11.119,14.397c0,8.228 6.706,14.898 14.978,14.898c0,0 0.001,0 0.001,0l35.155,0c0.001,0 0.001,0 0.001,0l0.001,0l2.094,0l0,-0.135c8.245,-1.027 14.625,-8.018 14.625,-16.496z",
    id: "svg_177",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1118.399,558.327l0,-38.946l7.342,-7.314l-3.153,-3.132l-7.366,7.337l-39.028,0l0,-7.788l-8.914,0l0,7.788l-7.868,0l0,8.866l7.868,0l0,42.054l42.205,0l0,7.788l8.914,0l0,-7.788l7.868,0l0,-8.866l-7.868,0.001l0,0zm-42.206,-33.188l30.126,0l-30.126,30.008l0,-30.008zm33.291,33.188l-30.184,0l30.185,-30.067l0,30.067l-0.001,0z",
    id: "svg_178",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1087.372,481.828l0,-38.946l7.342,-7.314l-3.153,-3.132l-7.366,7.337l-39.028,0l0,-7.788l-8.914,0l0,7.788l-7.868,0l0,8.866l7.868,0l0,42.054l42.205,0l0,7.788l8.914,0l0,-7.788l7.868,0l0,-8.866l-7.868,0.001l0,0zm-42.205,-33.189l30.126,0l-30.126,30.008l0,-30.008zm33.291,33.189l-30.185,0l30.185,-30.067l0,30.067z",
    id: "svg_179",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1018.559,265.272l0,-38.946l7.342,-7.314l-3.153,-3.132l-7.366,7.337l-39.028,0l0,-7.788l-8.914,0l0,7.788l-7.868,0l0,8.866l7.868,0l0,42.054l42.205,0l0,7.788l8.914,0l0,-7.788l7.868,0l0,-8.866l-7.868,0l0,0.001zm-42.205,-33.188l30.126,0l-30.126,30.008l0,-30.008zm33.291,33.188l-30.185,0l30.185,-30.067l0,30.067z",
    id: "svg_180",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1160.843,859.636l0,-38.946l7.342,-7.314l-3.153,-3.132l-7.366,7.337l-39.028,0l0,-7.788l-8.914,0l0,7.788l-7.868,0l0,8.866l7.868,0l0,42.054l42.205,0l0,7.788l8.914,0l0,-7.788l7.868,0l0,-8.866l-7.868,0l0,0.001zm-42.205,-33.188l30.126,0l-30.126,30.008l0,-30.008zm33.291,33.188l-30.185,0l30.185,-30.067l0,30.067z",
    id: "svg_181",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_182",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_183",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_184",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m894.024,541.828l-62.866,0c0,5.538 4.242,8.105 7.648,8.105l47.573,0c4.076,0 7.645,-3.186 7.645,-8.105z",
    id: "svg_185",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m884.781,500.329l-45.895,0l0,29.96c0,4.056 3.523,7.272 7.333,7.272l29.753,0c4.303,0 7.231,-3.59 7.231,-7.272l0,-2.502c8.483,0 14.645,-6.344 14.645,-13.729c0,-7.542 -6.04,-13.729 -13.067,-13.729zm7.655,13.738c0,4.305 -3.187,8.414 -9.234,8.025l0,-16.139l1.578,0.002l0.003,0.003c5.81,0 7.675,5.477 7.654,8.114l-0.001,-0.005z",
    id: "svg_186",
    fill: "#191a19",
    stroke: "null"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_187",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_188",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_189",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m722.854,656.559l-62.866,0c0,5.538 4.242,8.105 7.648,8.105l47.573,0c4.075,0 7.645,-3.186 7.645,-8.105z",
    id: "svg_190",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m713.61,615.06l-45.895,0l0,29.96c0,4.056 3.523,7.272 7.333,7.272l29.753,0c4.303,0 7.231,-3.59 7.231,-7.272l0,-2.502c8.483,0 14.645,-6.344 14.645,-13.729c0.001,-7.542 -6.04,-13.729 -13.067,-13.729zm7.655,13.737c0,4.305 -3.187,8.414 -9.234,8.025l0,-16.139l1.578,0.002l0.003,0.003c5.81,0 7.675,5.477 7.654,8.114l-0.001,-0.005z",
    id: "svg_191",
    fill: "#191a19",
    stroke: "null"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_192",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_193",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_194",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m944.638,611.525l-62.866,0c0,5.538 4.242,8.105 7.648,8.105l47.573,0c4.076,0.001 7.645,-3.186 7.645,-8.105z",
    id: "svg_195",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m935.394,570.026l-45.895,0l0,29.96c0,4.056 3.523,7.272 7.333,7.272l29.753,0c4.303,0 7.231,-3.59 7.231,-7.272l0,-2.502c8.483,0 14.645,-6.344 14.645,-13.729c0.001,-7.541 -6.039,-13.729 -13.067,-13.729zm7.656,13.738c0,4.305 -3.187,8.414 -9.234,8.025l0,-16.139l1.578,0.002l0.003,0.003c5.81,0 7.675,5.477 7.654,8.114l-0.001,-0.005z",
    id: "svg_196",
    fill: "#191a19",
    stroke: "null"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_197",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_198",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_199",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m271.32,957.429l-62.866,0c0,5.538 4.242,8.105 7.648,8.105l47.573,0c4.075,0 7.645,-3.186 7.645,-8.105z",
    id: "svg_200",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m262.076,915.93l-45.895,0l0,29.96c0,4.056 3.523,7.272 7.333,7.272l29.753,0c4.303,0 7.231,-3.59 7.231,-7.272l0,-2.502c8.483,0 14.645,-6.344 14.645,-13.729c0.001,-7.542 -6.04,-13.729 -13.067,-13.729zm7.655,13.737c0,4.305 -3.187,8.414 -9.234,8.025l0,-16.139l1.578,0.002l0.003,0.003c5.81,0 7.675,5.477 7.654,8.114l-0.001,-0.005z",
    id: "svg_201",
    fill: "#191a19",
    stroke: "null"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_202",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m796.744,995.155l40.017,37.15l-19.341,1.659l11.005,24.213l-7.336,3.316l-10.672,-24.545l-13.673,12.936l0,-54.729",
    id: "svg_203",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_204",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m1034.295,919.979l40.017,37.15l-19.341,1.659l11.005,24.213l-7.336,3.316l-10.672,-24.545l-13.673,12.936l0,-54.729",
    id: "svg_205",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_206",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m814.602,1198.459l40.017,37.15l-19.341,1.659l11.005,24.213l-7.336,3.316l-10.672,-24.544l-13.673,12.936l0,-54.73",
    id: "svg_207",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_208",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m305.621,1079.438l40.017,37.15l-19.341,1.659l11.005,24.213l-7.336,3.316l-10.672,-24.544l-13.673,12.936l0,-54.73",
    id: "svg_209",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_210",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_211",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_212",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m654.352,1101.389c0,2.74 -2.51,5.674 -5.764,5.674l0,28.373c0,6.566 -8.997,6.566 -8.997,0l0,-28.373c-3.169,0 -5.927,-2.428 -5.927,-6.064l0,-25.453c0,-2.215 3.22,-2.301 3.22,0.085l0,18.816l2.694,0l0,-18.987c0,-2.036 3.099,-2.168 3.099,0.085l0,18.901l2.785,0l0,-18.964c0,-2.126 3.009,-2.212 3.009,0.085l0,18.879l2.739,0l0,-18.964c0,-2.104 3.144,-2.19 3.144,0.085l-0.002,25.822z",
    id: "svg_213",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_214",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m678.352,1081.462l0,53.952c0,6.421 -9.015,6.326 -9.015,0l0,-20.427l-4.801,0l0,-33.524c0.001,-10.086 13.816,-10.086 13.816,-0.001z",
    id: "svg_215",
    fill: "#191a19",
    stroke: "null"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svg_216",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_217",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_218",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m632.84,573.552c0,2.74 -2.51,5.674 -5.764,5.674l0,28.373c0,6.565 -8.997,6.565 -8.997,0l0,-28.373c-3.169,0 -5.927,-2.428 -5.927,-6.065l0,-25.453c0,-2.215 3.22,-2.301 3.22,0.085l0,18.816l2.694,0l0,-18.987c0,-2.036 3.099,-2.168 3.099,0.085l0,18.901l2.785,0l0,-18.964c0,-2.126 3.009,-2.212 3.009,0.085l0,18.879l2.739,0l0,-18.964c0,-2.104 3.144,-2.19 3.144,0.085l-0.002,25.823z",
    id: "svg_219",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_220",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m656.84,553.624l0,53.952c0,6.421 -9.015,6.326 -9.015,0l0,-20.427l-4.801,0l0,-33.524c0,-10.086 13.816,-10.086 13.816,-0.001z",
    id: "svg_221",
    fill: "#191a19",
    stroke: "null"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svg_222",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_223",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_224",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m461.024,398.366c0,2.74 -2.51,5.674 -5.764,5.674l0,28.373c0,6.565 -8.997,6.565 -8.997,0l0,-28.373c-3.169,0 -5.927,-2.428 -5.927,-6.065l0,-25.453c0,-2.215 3.22,-2.301 3.22,0.085l0,18.816l2.694,0l0,-18.987c0,-2.036 3.099,-2.168 3.099,0.085l0,18.901l2.785,0l0,-18.962c0,-2.126 3.009,-2.212 3.009,0.085l0,18.879l2.739,0l0,-18.964c0,-2.104 3.144,-2.191 3.144,0.085l-0.002,25.821z",
    id: "svg_225",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_226",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m485.024,378.438l0,53.952c0,6.421 -9.015,6.326 -9.015,0l0,-20.427l-4.801,0l0,-33.524c0.001,-10.086 13.816,-10.086 13.816,-0.001z",
    id: "svg_227",
    fill: "#191a19",
    stroke: "null"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svg_228",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_229",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_230",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m618.526,751.184c0,2.74 -2.51,5.674 -5.764,5.674l0,28.373c0,6.565 -8.997,6.565 -8.997,0l0,-28.373c-3.169,0 -5.927,-2.428 -5.927,-6.065l0,-25.453c0,-2.215 3.22,-2.301 3.22,0.085l0,18.816l2.694,0l0,-18.987c0,-2.036 3.099,-2.168 3.099,0.085l0,18.901l2.785,0l0,-18.964c0,-2.126 3.009,-2.212 3.009,0.085l0,18.879l2.739,0l0,-18.964c0,-2.104 3.144,-2.191 3.144,0.085l-0.002,25.823z",
    id: "svg_231",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_232",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m642.526,731.257l0,53.952c0,6.421 -9.015,6.326 -9.015,0l0,-20.427l-4.801,0l0,-33.524c0.001,-10.087 13.816,-10.087 13.816,-0.001z",
    id: "svg_233",
    fill: "#191a19",
    stroke: "null"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m1246.602,849.782c-6.169,-6.136 -14.252,-9.204 -22.337,-9.203c-8.083,0.001 -16.17,3.068 -22.338,9.203c-12.337,12.271 -12.336,32.165 0,44.435c6.169,6.135 14.253,9.203 22.338,9.203s16.168,-3.067 22.337,-9.203c12.337,-12.27 12.337,-32.164 0,-44.435zm-22.335,1.88l0,0l0,0c5.46,0.001 10.594,2.116 14.456,5.958c3.863,3.841 5.989,8.948 5.989,14.38c0,3.433 -0.851,6.736 -2.452,9.671l-27.719,-27.57c2.952,-1.591 6.272,-2.439 9.726,-2.439zm-14.461,34.718c-3.862,-3.841 -5.989,-8.948 -5.989,-14.38c0,-3.433 0.851,-6.735 2.451,-9.671l27.719,27.57c-2.952,1.591 -6.271,2.438 -9.723,2.438c-5.461,0 -10.596,-2.115 -14.458,-5.957z",
    id: "svg_234",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m863.738,225.548c-6.169,-6.136 -14.252,-9.204 -22.337,-9.203c-8.083,0.001 -16.169,3.068 -22.337,9.203c-12.337,12.271 -12.336,32.165 0,44.435c6.169,6.135 14.253,9.203 22.337,9.203c8.084,0 16.168,-3.067 22.337,-9.203c12.337,-12.271 12.337,-32.165 0,-44.435zm-22.335,1.879l0,0l0,0c5.46,0.001 10.594,2.116 14.456,5.958c3.863,3.841 5.989,8.948 5.989,14.38c0,3.433 -0.851,6.736 -2.452,9.671l-27.719,-27.57c2.952,-1.591 6.273,-2.438 9.726,-2.439zm-14.461,34.719c-3.862,-3.841 -5.989,-8.948 -5.989,-14.38c0,-3.433 0.851,-6.735 2.451,-9.671l27.719,27.57c-2.952,1.591 -6.272,2.438 -9.723,2.438c-5.461,0 -10.596,-2.115 -14.458,-5.957z",
    id: "svg_235",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1005.693,921.961c-6.169,-6.136 -14.252,-9.204 -22.337,-9.203c-8.083,0.001 -16.169,3.068 -22.337,9.203c-12.337,12.271 -12.336,32.165 0,44.435c6.169,6.135 14.253,9.203 22.337,9.203s16.168,-3.067 22.337,-9.203c12.337,-12.271 12.337,-32.165 0,-44.435zm-22.335,1.879l0,0l0,0c5.46,0.001 10.594,2.116 14.456,5.958c3.863,3.841 5.989,8.948 5.989,14.38c0,3.433 -0.851,6.736 -2.452,9.671l-27.719,-27.57c2.952,-1.591 6.273,-2.438 9.726,-2.439zm-14.461,34.719c-3.862,-3.841 -5.989,-8.948 -5.989,-14.38c0,-3.433 0.851,-6.735 2.451,-9.671l27.719,27.57c-2.952,1.591 -6.272,2.438 -9.723,2.438c-5.461,0 -10.596,-2.115 -14.458,-5.957z",
    id: "svg_236",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1125.37,1052.534c-6.169,-6.136 -14.252,-9.204 -22.337,-9.203c-8.083,0 -16.169,3.068 -22.337,9.203c-12.337,12.271 -12.336,32.165 0,44.435c6.168,6.135 14.253,9.203 22.337,9.203s16.168,-3.067 22.337,-9.203c12.337,-12.27 12.337,-32.164 0,-44.435zm-22.336,1.88l0,0l0,0c5.46,0 10.594,2.116 14.456,5.958c3.863,3.841 5.989,8.948 5.989,14.38c0,3.433 -0.851,6.736 -2.452,9.671l-27.719,-27.57c2.953,-1.591 6.273,-2.439 9.726,-2.439zm-14.46,34.718c-3.862,-3.841 -5.989,-8.948 -5.989,-14.38c0,-3.433 0.851,-6.735 2.451,-9.671l27.719,27.57c-2.952,1.591 -6.272,2.438 -9.723,2.438c-5.461,0 -10.596,-2.115 -14.458,-5.957z",
    id: "svg_237",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "876.104,380.645 868.847,373.428 855.872,386.335 855.872,351.284 844.09,351.284 844.09,386.41      831.079,373.475 823.829,380.69 849.993,406.698 857.242,399.483 857.205,399.447    ",
    id: "svg_238",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "555.671,278.359 548.414,271.141 535.438,284.049 535.438,248.998 523.657,248.998 523.657,284.123      510.645,271.189 503.396,278.404 529.559,304.412 536.809,297.197 536.771,297.161    ",
    id: "svg_239",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "558.256,412.26 550.998,405.042 538.023,417.95 538.023,382.899 526.241,382.899 526.241,418.024 513.23,405.09      505.98,412.305 532.144,438.313 539.393,431.098 539.356,431.061    ",
    id: "svg_240",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.75,1065.336 400.493,1058.118 387.517,1071.026 387.517,1035.975 375.736,1035.975 375.736,1071.1      362.724,1058.166 355.475,1065.381 381.638,1091.389 388.888,1084.174 388.85,1084.137    ",
    id: "svg_241",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_242",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "822.467,809.027 829.008,815.535 829.015,815.528 829.047,815.56 835.581,809.064 835.547,809.03       852.577,792.088 846.037,785.583 834.346,797.212 834.346,772.255 823.73,772.255 823.73,797.283 811.998,785.62       805.468,792.126 822.47,809.024     ",
    id: "svg_243",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "849.637,808.358 849.637,825.536 807.852,825.536 807.852,808.358 798.381,808.358 798.381,834.957       807.852,834.957 807.852,834.957 849.637,834.957 849.637,834.957 859.108,834.957 859.108,808.358     ",
    id: "svg_244",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_245",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1034.697,756.342 1041.238,762.85 1041.245,762.843 1041.277,762.875 1047.811,756.379 1047.777,756.345       1064.807,739.403 1058.267,732.898 1046.576,744.527 1046.576,719.57 1035.96,719.57 1035.96,744.598 1024.228,732.935       1017.698,739.441 1034.7,756.339     ",
    id: "svg_246",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1061.867,755.673 1061.867,772.851 1020.082,772.851 1020.082,755.673 1010.611,755.673 1010.611,782.272       1020.082,782.272 1020.082,782.271 1061.867,782.271 1061.867,782.272 1071.338,782.272 1071.338,755.673     ",
    id: "svg_247",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_248",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "60.494,578.178 67.035,584.685 67.042,584.678 67.074,584.71 73.608,578.215 73.574,578.18 90.604,561.239       84.064,554.734 72.373,566.362 72.373,541.405 61.757,541.405 61.757,566.433 50.025,554.77 43.495,561.276 60.497,578.174           ",
    id: "svg_249",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.664,577.509 87.664,594.687 45.879,594.687 45.879,577.509 36.408,577.509 36.408,604.108 45.879,604.108       45.879,604.107 87.664,604.107 87.664,604.108 97.135,604.108 97.135,577.509     ",
    id: "svg_250",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_251",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "971.759,168.995 978.299,175.503 978.307,175.496 978.339,175.528 984.873,169.032 984.839,168.998       1001.869,152.056 995.329,145.551 983.638,157.18 983.638,132.223 973.022,132.223 973.022,157.251 961.29,145.588       954.76,152.094 971.762,168.992     ",
    id: "svg_252",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "998.929,168.326 998.929,185.504 957.144,185.504 957.144,168.326 947.673,168.326 947.673,194.925       957.144,194.925 957.144,194.924 998.929,194.924 998.929,194.925 1008.4,194.925 1008.4,168.326     ",
    id: "svg_253",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_254",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "835.256,965.085 841.8,958.58 841.792,958.573 841.824,958.54 835.294,952.042 835.26,952.075 818.226,935.136       811.685,941.641 823.377,953.27 798.286,953.27 798.286,963.829 823.449,963.829 811.723,975.498 818.263,981.993       835.253,965.082     ",
    id: "svg_255",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "861.325,938.061 861.325,928.641 834.583,928.641 834.583,938.061 851.854,938.061 851.854,979.622       834.583,979.622 834.583,989.042 861.325,989.042 861.325,979.622 861.325,979.622 861.325,938.061     ",
    id: "svg_256",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_257",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "642.227,963.253 648.771,956.748 648.763,956.741 648.795,956.708 642.265,950.209 642.231,950.243       625.197,933.304 618.656,939.809 630.348,951.438 605.257,951.438 605.257,961.997 630.42,961.997 618.694,973.666       625.234,980.161 642.224,963.25     ",
    id: "svg_258",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "668.296,936.229 668.296,926.809 641.554,926.809 641.554,936.229 658.825,936.229 658.825,977.79       641.554,977.79 641.554,987.21 668.296,987.21 668.296,977.79 668.296,977.79 668.296,936.229     ",
    id: "svg_259",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_260",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "929.431,1057.583 935.975,1051.077 935.967,1051.07 935.999,1051.038 929.469,1044.539 929.435,1044.572       912.401,1027.633 905.86,1034.139 917.552,1045.767 892.461,1045.767 892.461,1056.326 917.624,1056.326 905.898,1067.995       912.438,1074.49 929.428,1057.579     ",
    id: "svg_261",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "955.5,1030.558 955.5,1021.138 928.758,1021.138 928.758,1030.558 946.029,1030.558 946.029,1072.119       928.758,1072.119 928.758,1081.539 955.5,1081.539 955.5,1072.119 955.5,1072.119 955.5,1030.558     ",
    id: "svg_262",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_263",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1062.503,839.997 1069.046,833.492 1069.039,833.484 1069.071,833.452 1062.54,826.953 1062.506,826.987       1045.473,810.048 1038.932,816.553 1050.624,828.182 1025.532,828.182 1025.532,838.741 1050.695,838.741 1038.969,850.409       1045.51,856.905 1062.5,839.994     ",
    id: "svg_264",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1088.572,812.973 1088.572,803.553 1061.83,803.553 1061.83,812.973 1079.1,812.973 1079.1,854.533       1061.83,854.533 1061.83,863.954 1088.572,863.954 1088.572,854.533 1088.571,854.533 1088.571,812.973     ",
    id: "svg_265",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_266",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "418.251,373.149 385.585,398.881 352.918,373.149     ",
    id: "svg_267",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.251,409.983 398.604,394.464 418.251,378.945     ",
    id: "svg_268",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.829,378.945 372.477,394.464 352.829,409.983     ",
    id: "svg_269",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.006,397.219 385.629,404.577 376.251,397.219 352.918,415.525 371.673,415.525 399.584,415.525       418.339,415.525     ",
    id: "svg_270",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_271",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "372.242,146.47 339.576,172.202 306.909,146.47     ",
    id: "svg_272",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.242,183.304 352.595,167.785 372.242,152.266     ",
    id: "svg_273",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.821,152.266 326.468,167.785 306.821,183.304     ",
    id: "svg_274",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.997,170.54 339.62,177.897 330.242,170.54 306.909,188.846 325.664,188.846 353.575,188.846       372.33,188.846     ",
    id: "svg_275",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_276",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "618.675,488.971 586.009,514.703 553.342,488.971     ",
    id: "svg_277",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "618.675,525.806 599.028,510.286 618.675,494.768     ",
    id: "svg_278",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "553.254,494.768 572.901,510.286 553.254,525.806     ",
    id: "svg_279",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "595.43,513.042 586.053,520.399 576.675,513.042 553.342,531.348 572.097,531.348 600.008,531.348       618.763,531.348     ",
    id: "svg_280",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_281",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "188.465,949.944 155.799,975.676 123.132,949.944     ",
    id: "svg_282",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.465,986.778 168.818,971.259 188.465,955.74     ",
    id: "svg_283",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.044,955.74 142.691,971.259 123.044,986.778     ",
    id: "svg_284",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.22,974.014 155.843,981.371 146.465,974.014 123.132,992.32 141.887,992.32 169.798,992.32 188.553,992.32           ",
    id: "svg_285",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_286",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "962.884,394.56 956.353,388.061 956.319,388.096 939.286,371.156 932.745,377.661       944.436,389.29 919.345,389.29 919.345,399.849 944.508,399.849 932.782,411.518 939.322,418.013 956.312,401.102       956.315,401.105 962.859,394.6 962.852,394.593     ",
    id: "svg_287",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "908.76,373.527 926.031,373.527 926.031,364.107 899.288,364.107 899.288,366.046       899.288,373.527 899.288,415.087 899.288,423.122 899.288,424.508 926.031,424.508 926.031,415.087 908.76,415.087     ",
    id: "svg_288",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_289",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "1037.576,1150.689 1031.044,1144.19 1031.01,1144.225 1013.977,1127.285 1007.437,1133.79       1019.128,1145.419 994.037,1145.419 994.037,1155.978 1019.199,1155.978 1007.474,1167.647 1014.014,1174.142       1031.004,1157.231 1031.007,1157.234 1037.551,1150.729 1037.543,1150.722     ",
    id: "svg_290",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "983.451,1129.656 1000.722,1129.656 1000.722,1120.236 973.98,1120.236 973.98,1122.175       973.98,1129.656 973.98,1171.216 973.98,1179.251 973.98,1180.637 1000.722,1180.637 1000.722,1171.216 983.451,1171.216           ",
    id: "svg_291",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_292",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "833.532,673.853 827.001,667.354 826.967,667.388 809.934,650.449 803.393,656.954       815.084,668.582 789.993,668.582 789.993,679.141 815.155,679.141 803.43,690.81 809.97,697.306 826.96,680.394       826.963,680.398 833.507,673.893 833.499,673.885     ",
    id: "svg_293",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "779.407,652.819 796.678,652.819 796.678,643.399 769.936,643.399 769.936,645.338       769.936,652.819 769.936,694.38 769.936,702.415 769.936,703.8 796.678,703.8 796.678,694.38 779.407,694.38     ",
    id: "svg_294",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_295",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "918.821,1101.457 912.29,1094.958 912.256,1094.992 895.223,1078.052 888.682,1084.557       900.374,1096.186 875.282,1096.186 875.282,1106.745 900.445,1106.745 888.72,1118.414 895.26,1124.909 912.25,1107.998       912.253,1108.001 918.796,1101.496 918.789,1101.489     ",
    id: "svg_296",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "864.697,1080.423 881.968,1080.423 881.968,1071.003 855.226,1071.003 855.226,1072.942       855.226,1080.423 855.226,1121.984 855.226,1130.019 855.226,1131.404 881.968,1131.404 881.968,1121.984 864.697,1121.984           ",
    id: "svg_297",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_298",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m763.503,260.056c-20.958,0 -33.398,22.67 -33.398,22.67s12.44,22.67 33.398,22.67s33.398,-22.67 33.398,-22.67s-12.44,-22.67 -33.398,-22.67zm0,36.196c-7.498,0 -13.599,-6.068 -13.599,-13.526c0,-7.458 6.101,-13.526 13.599,-13.526c7.498,0 13.599,6.068 13.599,13.526c0,7.459 -6.101,13.526 -13.599,13.526z",
    id: "svg_299",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 763.503,
    cy: 283.05,
    rx: 8.028,
    ry: 7.985,
    id: "svg_300",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_301",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m943.618,1159.01c-20.958,0 -33.398,22.67 -33.398,22.67s12.44,22.67 33.398,22.67s33.398,-22.67 33.398,-22.67s-12.44,-22.67 -33.398,-22.67zm0,36.197c-7.498,0 -13.599,-6.068 -13.599,-13.526c0,-7.458 6.101,-13.526 13.599,-13.526s13.599,6.068 13.599,13.526c0,7.458 -6.101,13.526 -13.599,13.526z",
    id: "svg_302",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 943.618,
    cy: 1182.004,
    rx: 8.028,
    ry: 7.985,
    id: "svg_303",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_304",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m917.831,244.258c-20.958,0 -33.398,22.67 -33.398,22.67s12.44,22.67 33.398,22.67c20.958,0 33.398,-22.67 33.398,-22.67s-12.44,-22.67 -33.398,-22.67zm0,36.197c-7.498,0 -13.599,-6.068 -13.599,-13.526s6.101,-13.526 13.599,-13.526s13.599,6.068 13.599,13.526c-0.001,7.459 -6.101,13.526 -13.599,13.526z",
    id: "svg_305",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 917.831,
    cy: 267.253,
    rx: 8.028,
    ry: 7.985,
    id: "svg_306",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_307",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m580.798,425.728c-20.958,0 -33.398,22.67 -33.398,22.67s12.44,22.67 33.398,22.67s33.398,-22.67 33.398,-22.67s-12.44,-22.67 -33.398,-22.67zm-0.001,36.196c-7.498,0 -13.599,-6.068 -13.599,-13.526c0,-7.458 6.101,-13.526 13.599,-13.526c7.498,0 13.599,6.068 13.599,13.526c0,7.459 -6.1,13.526 -13.599,13.526z",
    id: "svg_308",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 580.798,
    cy: 448.722,
    rx: 8.028,
    ry: 7.985,
    id: "svg_309",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_310",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "160.506,593.044 112.222,593.044 112.222,526.548 134.192,526.548 134.192,552.204 160.506,552.204     ",
    id: "svg_311",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.936,526.548 138.936,548.002 160.506,548.002     ",
    id: "svg_312",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_313",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "203.888,756.318 155.604,756.318 155.604,689.821 177.574,689.821 177.574,715.477 203.888,715.477     ",
    id: "svg_314",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.319,689.821 182.319,711.275 203.888,711.275     ",
    id: "svg_315",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_316",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "810.945,910.684 762.661,910.684 762.661,844.187 784.631,844.187 784.631,869.844 810.945,869.844     ",
    id: "svg_317",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "789.375,844.187 789.375,865.642 810.945,865.642     ",
    id: "svg_318",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_319",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "512.237,254.606 463.953,254.606 463.953,188.11 485.923,188.11 485.923,213.766 512.237,213.766     ",
    id: "svg_320",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.667,188.11 490.667,209.564 512.237,209.564     ",
    id: "svg_321",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_322",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m791.852,370.886c0,0 -0.619,7.538 -13.822,20.669c-1.675,1.666 -3.024,3.369 -4.114,5.069c-5.184,-6.526 -6.258,-13.507 -6.258,-13.507c-11.494,11.432 -10.742,26.304 -10.742,34.541c0,8.235 6.713,14.911 14.992,14.911c2.946,0 7.335,-0.31 11.768,-1.076c2.074,0.694 4.293,1.077 6.603,1.077c11.428,-0.001 20.693,-9.216 20.693,-20.582c0.002,-11.369 -3.254,-25.323 -19.12,-41.102zm0.615,34.889c3.91,3.889 4.575,8.144 4.575,11.071c0,6.159 -5.02,11.152 -11.212,11.152c-6.193,0 -11.213,-4.993 -11.212,-11.152c0,-6.159 1.764,-13.721 10.36,-22.271c0,0 0.335,4.085 7.489,11.2z",
    id: "svg_323",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_324",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m308.839,367.416c0,0 -0.619,7.538 -13.822,20.669c-1.675,1.666 -3.024,3.369 -4.114,5.069c-5.184,-6.526 -6.258,-13.507 -6.258,-13.507c-11.494,11.432 -10.742,26.304 -10.742,34.541c0,8.235 6.713,14.911 14.992,14.911c2.946,0 7.335,-0.31 11.768,-1.076c2.074,0.694 4.293,1.077 6.603,1.077c11.428,-0.001 20.693,-9.216 20.693,-20.582c0.002,-11.369 -3.254,-25.322 -19.12,-41.102zm0.615,34.89c3.91,3.889 4.575,8.144 4.575,11.071c0,6.159 -5.02,11.152 -11.212,11.152c-6.192,0 -11.213,-4.993 -11.212,-11.152c0,-6.159 1.764,-13.72 10.36,-22.271c-0.001,-0.001 0.335,4.084 7.489,11.2z",
    id: "svg_325",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_326",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m510.974,437.401c0,0 -0.619,7.538 -13.822,20.669c-1.675,1.666 -3.024,3.369 -4.114,5.069c-5.184,-6.526 -6.258,-13.507 -6.258,-13.507c-11.494,11.432 -10.742,26.304 -10.742,34.541c0,8.235 6.713,14.911 14.992,14.911c2.946,0 7.335,-0.31 11.768,-1.076c2.074,0.694 4.293,1.077 6.603,1.077c11.428,-0.001 20.693,-9.216 20.693,-20.582c0.001,-11.369 -3.255,-25.322 -19.12,-41.102zm0.614,34.89c3.91,3.889 4.575,8.144 4.575,11.071c0,6.159 -5.02,11.152 -11.212,11.152c-6.192,0 -11.213,-4.993 -11.212,-11.152c0,-6.159 1.764,-13.721 10.36,-22.271c0,-0.001 0.335,4.084 7.489,11.2z",
    id: "svg_327",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_328",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m508.757,58.636c0,0 -0.619,7.538 -13.822,20.669c-1.675,1.666 -3.024,3.369 -4.114,5.069c-5.184,-6.526 -6.258,-13.507 -6.258,-13.507c-11.494,11.432 -10.742,26.304 -10.742,34.541c0,8.235 6.713,14.911 14.992,14.911c2.946,0 7.335,-0.31 11.768,-1.076c2.074,0.694 4.293,1.077 6.603,1.077c11.428,-0.001 20.693,-9.216 20.693,-20.582c0.001,-11.369 -3.255,-25.323 -19.12,-41.102zm0.614,34.889c3.91,3.889 4.575,8.144 4.575,11.071c0,6.159 -5.02,11.152 -11.212,11.152c-6.192,0 -11.213,-4.993 -11.212,-11.152c0,-6.159 1.764,-13.721 10.36,-22.271c0,0 0.335,4.085 7.489,11.2z",
    id: "svg_329",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_330",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "675.836,193.161 682.522,226.777 736.006,226.777 742.691,193.161     ",
    id: "svg_331",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "737.747,188.541 735.518,179.619 708.682,179.619 706.783,172.216 684.968,172.216 680.781,188.541       710.971,188.541     ",
    id: "svg_332",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_333",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "867.382,117.069 874.068,150.685 927.552,150.685 934.238,117.069     ",
    id: "svg_334",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "929.293,112.449 927.065,103.527 900.228,103.527 898.329,96.125 876.514,96.125 872.327,112.449       902.517,112.449     ",
    id: "svg_335",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_336",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1130.271,539.356 1136.957,572.971 1190.441,572.971 1197.126,539.356     ",
    id: "svg_337",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1192.182,534.736 1189.953,525.814 1163.117,525.814 1161.218,518.411 1139.403,518.411 1135.216,534.736       1165.406,534.736     ",
    id: "svg_338",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_339",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "698.386,121.768 705.071,155.383 758.555,155.383 765.241,121.768     ",
    id: "svg_340",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "760.296,117.147 758.068,108.225 731.232,108.225 729.332,100.823 707.518,100.823 703.33,117.147       733.52,117.147     ",
    id: "svg_341",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_342",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m335.293,823.077c1.232,0 2.379,-0.994 2.547,-2.208c0,0 0.235,-1.707 0.235,-3.738c0,-2.03 -0.235,-3.738 -0.235,-3.738c-0.169,-1.215 -1.315,-2.209 -2.547,-2.209l-6.37,0c-1.233,0 -2.514,-0.782 -2.845,-1.737c-0.331,-0.955 -0.788,-4.02 0.084,-4.887l4.502,-4.478c0.871,-0.867 0.939,-2.347 0.15,-3.29l-5.297,-5.27c-0.948,-0.786 -2.435,-0.719 -3.308,0.149l-4.502,4.478c-0.871,0.868 -2.325,1.217 -3.227,0.777c-0.903,-0.44 -3.434,-2.296 -3.434,-3.522l0,-6.335c0,-1.226 -0.999,-2.367 -2.22,-2.534c0,0 -1.716,-0.235 -3.758,-0.235s-3.758,0.235 -3.758,0.235c-1.222,0.167 -2.222,1.307 -2.222,2.534l0,6.335c0,1.226 -0.786,2.5 -1.747,2.829c-0.961,0.33 -4.042,0.784 -4.914,-0.084l-4.502,-4.478c-0.872,-0.867 -2.36,-0.934 -3.307,-0.149l-5.298,5.269c-0.79,0.943 -0.723,2.422 0.149,3.29l4.502,4.478c0.872,0.867 1.224,2.312 0.781,3.21s-2.308,3.415 -3.541,3.415l-6.369,0c-1.233,0 -2.379,0.994 -2.548,2.209c0,0 -0.236,1.707 -0.236,3.737c0,2.031 0.236,3.737 0.236,3.737c0.168,1.216 1.314,2.209 2.548,2.209l6.37,0c1.233,0 2.513,0.781 2.844,1.737c0.331,0.956 0.788,4.02 -0.085,4.886l-4.502,4.478c-0.872,0.867 -0.939,2.347 -0.149,3.291l5.297,5.269c0.948,0.785 2.435,0.72 3.307,-0.149l4.502,-4.477c0.872,-0.867 2.324,-1.216 3.227,-0.776c0.903,0.44 3.433,2.296 3.433,3.522l0,6.336c0,1.226 0.999,2.366 2.222,2.532c0,0 1.716,0.235 3.758,0.235s3.758,-0.235 3.758,-0.235c1.222,-0.167 2.22,-1.307 2.22,-2.532l0,-6.336c0,-1.226 0.786,-2.5 1.747,-2.829c0.962,-0.33 4.043,-0.783 4.914,0.084l4.502,4.478c0.872,0.866 2.36,0.934 3.308,0.149l5.297,-5.268c0.789,-0.943 0.724,-2.422 -0.15,-3.29l-4.502,-4.477c-0.872,-0.867 -1.224,-2.312 -0.781,-3.21c0.442,-0.898 2.308,-3.415 3.541,-3.415l6.373,-0.002l0,0zm-30.225,6.071c-6.673,0 -12.082,-5.379 -12.082,-12.018c0,-6.636 5.409,-12.017 12.082,-12.017s12.082,5.38 12.082,12.017c0.001,6.637 -5.409,12.018 -12.082,12.018z",
    id: "svg_343",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_344",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m140.186,713.053c1.232,0 2.379,-0.994 2.547,-2.208c0,0 0.235,-1.707 0.235,-3.738c0,-2.03 -0.235,-3.738 -0.235,-3.738c-0.169,-1.215 -1.315,-2.209 -2.547,-2.209l-6.37,0c-1.233,0 -2.514,-0.782 -2.845,-1.737s-0.788,-4.02 0.084,-4.887l4.502,-4.478c0.871,-0.867 0.939,-2.347 0.15,-3.29l-5.297,-5.27c-0.948,-0.786 -2.435,-0.719 -3.308,0.148l-4.502,4.478c-0.871,0.868 -2.325,1.217 -3.227,0.777c-0.903,-0.44 -3.434,-2.296 -3.434,-3.522l0,-6.336c0,-1.226 -0.999,-2.367 -2.22,-2.534c0,0 -1.716,-0.235 -3.758,-0.235s-3.758,0.235 -3.758,0.235c-1.222,0.167 -2.222,1.307 -2.222,2.534l0,6.336c0,1.226 -0.786,2.5 -1.747,2.829c-0.961,0.33 -4.042,0.784 -4.914,-0.084l-4.502,-4.478c-0.872,-0.867 -2.36,-0.934 -3.307,-0.149l-5.298,5.269c-0.79,0.943 -0.723,2.422 0.149,3.29l4.502,4.478c0.872,0.867 1.224,2.312 0.781,3.21s-2.308,3.415 -3.541,3.415l-6.369,0c-1.233,0 -2.379,0.994 -2.548,2.209c0,0 -0.236,1.707 -0.236,3.737c0,2.031 0.236,3.737 0.236,3.737c0.168,1.216 1.314,2.209 2.548,2.209l6.37,0c1.233,0 2.513,0.781 2.844,1.737c0.331,0.956 0.788,4.02 -0.085,4.886l-4.502,4.478c-0.872,0.867 -0.939,2.347 -0.149,3.29l5.297,5.269c0.948,0.785 2.435,0.72 3.307,-0.149l4.502,-4.477c0.872,-0.867 2.324,-1.216 3.227,-0.776c0.903,0.44 3.433,2.296 3.433,3.522l0,6.335c0,1.226 0.999,2.366 2.222,2.532c0,0 1.716,0.235 3.758,0.235c2.042,0 3.758,-0.235 3.758,-0.235c1.222,-0.167 2.22,-1.307 2.22,-2.532l0,-6.335c0,-1.226 0.786,-2.5 1.747,-2.829c0.962,-0.33 4.042,-0.783 4.914,0.084l4.502,4.478c0.872,0.866 2.36,0.934 3.308,0.148l5.297,-5.268c0.789,-0.943 0.724,-2.422 -0.15,-3.29l-4.502,-4.477c-0.872,-0.867 -1.224,-2.312 -0.781,-3.21c0.442,-0.898 2.308,-3.415 3.541,-3.415l6.373,0.001l0,0zm-30.224,6.071c-6.673,0 -12.082,-5.379 -12.082,-12.018c0,-6.636 5.409,-12.017 12.082,-12.017c6.673,0 12.082,5.38 12.082,12.017c0,6.638 -5.41,12.018 -12.082,12.018z",
    id: "svg_345",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_346",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m1281.762,793.515c1.232,0 2.38,-0.994 2.547,-2.208c0,0 0.235,-1.707 0.235,-3.738c0,-2.03 -0.235,-3.738 -0.235,-3.738c-0.169,-1.215 -1.315,-2.209 -2.547,-2.209l-6.37,0c-1.233,0 -2.514,-0.782 -2.845,-1.737c-0.331,-0.955 -0.788,-4.02 0.084,-4.887l4.502,-4.478c0.871,-0.867 0.939,-2.347 0.15,-3.29l-5.297,-5.27c-0.948,-0.786 -2.435,-0.719 -3.308,0.149l-4.502,4.478c-0.871,0.868 -2.325,1.217 -3.228,0.777s-3.434,-2.296 -3.434,-3.522l0,-6.335c0,-1.226 -1,-2.367 -2.22,-2.534c0,0 -1.717,-0.235 -3.758,-0.235c-2.041,0 -3.758,0.235 -3.758,0.235c-1.222,0.167 -2.222,1.307 -2.222,2.534l0,6.335c0,1.226 -0.786,2.5 -1.747,2.829s-4.042,0.784 -4.914,-0.084l-4.502,-4.478c-0.872,-0.867 -2.36,-0.934 -3.307,-0.149l-5.298,5.269c-0.79,0.943 -0.723,2.422 0.149,3.29l4.502,4.478c0.872,0.867 1.224,2.312 0.781,3.21c-0.443,0.898 -2.308,3.415 -3.541,3.415l-6.369,0c-1.233,0 -2.379,0.994 -2.548,2.209c0,0 -0.236,1.707 -0.236,3.737c0,2.031 0.236,3.737 0.236,3.737c0.168,1.216 1.314,2.209 2.548,2.209l6.37,0c1.233,0 2.513,0.781 2.844,1.737c0.332,0.956 0.788,4.02 -0.085,4.886l-4.502,4.478c-0.872,0.867 -0.939,2.347 -0.149,3.29l5.297,5.269c0.948,0.785 2.435,0.72 3.307,-0.149l4.502,-4.477c0.872,-0.867 2.324,-1.216 3.227,-0.776c0.903,0.44 3.433,2.296 3.433,3.522l0,6.336c0,1.226 1,2.366 2.222,2.532c0,0 1.716,0.235 3.758,0.235c2.042,0 3.758,-0.235 3.758,-0.235c1.222,-0.167 2.22,-1.307 2.22,-2.532l0,-6.336c0,-1.226 0.786,-2.5 1.747,-2.829c0.962,-0.33 4.042,-0.783 4.914,0.084l4.502,4.478c0.872,0.866 2.36,0.934 3.308,0.149l5.297,-5.268c0.789,-0.943 0.724,-2.422 -0.15,-3.29l-4.502,-4.477c-0.872,-0.867 -1.224,-2.312 -0.781,-3.21c0.442,-0.898 2.308,-3.415 3.541,-3.415l6.374,-0.001l0,0zm-30.225,6.072c-6.673,0 -12.082,-5.379 -12.082,-12.018c0,-6.636 5.409,-12.017 12.082,-12.017c6.673,0 12.082,5.38 12.082,12.017c0,6.637 -5.409,12.018 -12.082,12.018z",
    id: "svg_347",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_348",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m1008.469,339.759c1.232,0 2.379,-0.994 2.547,-2.208c0,0 0.235,-1.707 0.235,-3.738s-0.235,-3.738 -0.235,-3.738c-0.169,-1.215 -1.315,-2.209 -2.547,-2.209l-6.37,0c-1.233,0 -2.514,-0.782 -2.845,-1.737c-0.331,-0.955 -0.788,-4.02 0.084,-4.887l4.502,-4.478c0.871,-0.867 0.939,-2.347 0.15,-3.29l-5.297,-5.27c-0.948,-0.786 -2.435,-0.719 -3.308,0.148l-4.502,4.478c-0.871,0.868 -2.325,1.217 -3.227,0.777c-0.903,-0.44 -3.434,-2.296 -3.434,-3.522l0,-6.335c0,-1.226 -1,-2.367 -2.22,-2.534c0,0 -1.716,-0.235 -3.758,-0.235s-3.758,0.235 -3.758,0.235c-1.222,0.167 -2.222,1.307 -2.222,2.534l0,6.335c0,1.226 -0.786,2.5 -1.747,2.829s-4.042,0.784 -4.914,-0.084l-4.502,-4.478c-0.872,-0.867 -2.36,-0.934 -3.307,-0.149l-5.298,5.269c-0.79,0.943 -0.723,2.422 0.149,3.29l4.502,4.478c0.872,0.867 1.224,2.312 0.781,3.21c-0.443,0.898 -2.308,3.415 -3.541,3.415l-6.369,0c-1.233,0 -2.38,0.994 -2.548,2.209c0,0 -0.236,1.707 -0.236,3.737c0,2.031 0.236,3.737 0.236,3.737c0.168,1.216 1.314,2.209 2.548,2.209l6.37,0c1.233,0 2.513,0.781 2.844,1.737c0.331,0.956 0.788,4.02 -0.085,4.886l-4.502,4.478c-0.872,0.867 -0.939,2.347 -0.149,3.29l5.297,5.269c0.948,0.785 2.435,0.72 3.307,-0.149l4.502,-4.477c0.872,-0.867 2.324,-1.216 3.227,-0.776c0.903,0.44 3.433,2.296 3.433,3.522l0,6.335c0,1.226 1,2.366 2.222,2.532c0,0 1.716,0.235 3.758,0.235c2.042,0 3.758,-0.235 3.758,-0.235c1.222,-0.167 2.22,-1.307 2.22,-2.532l0,-6.335c0,-1.226 0.786,-2.5 1.747,-2.829c0.962,-0.33 4.043,-0.783 4.914,0.084l4.502,4.478c0.872,0.866 2.36,0.934 3.308,0.148l5.297,-5.268c0.789,-0.943 0.724,-2.422 -0.15,-3.29l-4.502,-4.477c-0.872,-0.867 -1.224,-2.312 -0.781,-3.21c0.442,-0.898 2.308,-3.415 3.541,-3.415l6.373,0.001l0,0zm-30.224,6.072c-6.673,0 -12.082,-5.379 -12.082,-12.018c0,-6.636 5.409,-12.017 12.082,-12.017c6.673,0 12.082,5.38 12.082,12.017s-5.41,12.018 -12.082,12.018z",
    id: "svg_349",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_350",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m820.355,199.497c2.409,-2.388 16.133,-16.056 24.69,-24.574c7.678,-7.637 7.519,-18.767 0.552,-25.681c-7,-6.905 -18.292,-6.88 -25.233,0.075c-6.95,-6.954 -18.241,-6.979 -25.225,-0.075c-6.975,6.913 -7.142,18.043 0.535,25.681c8.564,8.518 22.289,22.186 24.681,24.574z",
    id: "svg_351",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_352",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m306.253,913.971c2.408,-2.388 16.133,-16.056 24.69,-24.574c7.678,-7.637 7.519,-18.767 0.552,-25.681c-7,-6.905 -18.292,-6.88 -25.233,0.075c-6.95,-6.954 -18.241,-6.979 -25.225,-0.075c-6.975,6.913 -7.142,18.043 0.535,25.681c8.565,8.518 22.29,22.186 24.681,24.574z",
    id: "svg_353",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_354",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m502.884,1028.139c2.408,-2.388 16.133,-16.056 24.69,-24.574c7.678,-7.637 7.519,-18.767 0.552,-25.681c-7,-6.905 -18.292,-6.88 -25.233,0.075c-6.95,-6.954 -18.241,-6.979 -25.225,-0.075c-6.975,6.913 -7.142,18.043 0.535,25.681c8.564,8.518 22.289,22.186 24.681,24.574z",
    id: "svg_355",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_356",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1030.253,419.55c2.408,-2.388 16.133,-16.056 24.69,-24.574c7.678,-7.637 7.519,-18.767 0.552,-25.681c-7,-6.905 -18.292,-6.88 -25.233,0.075c-6.95,-6.954 -18.241,-6.979 -25.225,-0.075c-6.975,6.913 -7.142,18.043 0.535,25.681c8.564,8.519 22.289,22.186 24.681,24.574z",
    id: "svg_357",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "242.179,279.743 208.935,246.495 175.69,279.743 185.435,279.743 185.435,312.991 200.307,312.991      200.307,289.365 217.563,289.365 217.563,312.991 232.435,312.991 232.435,279.743    ",
    id: "svg_358",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "707.834,808.558 674.589,775.31 641.345,808.558 651.09,808.558 651.09,841.806 665.962,841.806      665.962,818.179 683.218,818.179 683.218,841.806 698.09,841.806 698.09,808.558    ",
    id: "svg_359",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "632.659,894.489 599.414,861.241 566.169,894.489 575.914,894.489 575.914,927.737 590.787,927.737      590.787,904.11 608.042,904.11 608.042,927.737 622.914,927.737 622.914,894.489    ",
    id: "svg_360",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1160.332,691.151 1127.087,657.903 1093.843,691.151 1103.588,691.151 1103.588,724.4 1118.46,724.4      1118.46,700.773 1135.715,700.773 1135.715,724.4 1150.588,724.4 1150.588,691.151    ",
    id: "svg_361",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_362",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m747.249,1083.947c-10.848,0 -17.705,4.986 -21.785,9.044c-6.672,6.636 -8.158,16.474 -4.465,24.54l26.241,-17.694l-24.09,23.96l-10.187,10.132l4.808,4.782l11.698,-11.635c8.479,5.212 19.745,4.167 27.099,-3.149c8.589,-8.543 16.687,-21.464 16.687,-45.184c0.001,0.002 -6.161,5.204 -26.006,5.204zm-0.008,15.89l0,0l0,0l0,0z",
    id: "svg_363",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_364",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m746.432,798.928c-10.848,0 -17.705,4.986 -21.785,9.044c-6.672,6.636 -8.158,16.474 -4.465,24.54l26.241,-17.694l-24.09,23.961l-10.187,10.132l4.808,4.782l11.698,-11.635c8.479,5.212 19.745,4.167 27.099,-3.149c8.589,-8.543 16.687,-21.464 16.687,-45.184c0.001,0.002 -6.161,5.203 -26.006,5.203zm-0.008,15.891l0,0l0,0l0,0z",
    id: "svg_365",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_366",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m234.653,849.297c-10.848,0 -17.705,4.986 -21.785,9.044c-6.672,6.636 -8.158,16.474 -4.465,24.54l26.241,-17.694l-24.09,23.96l-10.187,10.132l4.808,4.782l11.698,-11.635c8.479,5.212 19.745,4.167 27.099,-3.149c8.589,-8.543 16.687,-21.464 16.687,-45.184c0.001,0.003 -6.161,5.204 -26.006,5.204zm-0.008,15.891l0,0l0,0l0,0z",
    id: "svg_367",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_368",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m1091.755,886.324c-10.848,0 -17.705,4.986 -21.785,9.044c-6.672,6.636 -8.158,16.474 -4.465,24.54l26.241,-17.694l-24.09,23.96l-10.187,10.132l4.808,4.782l11.698,-11.635c8.479,5.212 19.745,4.167 27.099,-3.149c8.589,-8.543 16.687,-21.464 16.687,-45.184c0,0.002 -6.161,5.204 -26.006,5.204zm-0.009,15.89l0,0l0,0l0,0z",
    id: "svg_369",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "597.162,1098.951 559.52,1098.951 573.379,1085.158 565.647,1077.472 545.345,1097.677 537.821,1105.161      537.823,1105.163 537.774,1105.211 545.506,1112.897 545.552,1112.851 565.695,1132.886 573.43,1125.192 559.606,1111.442      597.162,1111.442    ",
    id: "svg_370",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "770.374,679.104 732.731,679.104 746.59,665.311 738.858,657.625 718.556,677.83 711.032,685.314      711.034,685.316 710.986,685.364 718.717,693.05 718.764,693.004 738.907,713.039 746.642,705.345 732.817,691.595      770.374,691.595    ",
    id: "svg_371",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "709.422,490.136 671.779,490.136 685.638,476.343 677.906,468.657 657.604,488.862 650.08,496.346      650.082,496.348 650.033,496.396 657.765,504.082 657.812,504.036 677.954,524.071 685.69,516.377 671.865,502.627      709.422,502.627    ",
    id: "svg_372",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.092,375.612 588.45,375.612 602.308,361.819 594.576,354.132 574.274,374.338 566.75,381.821      566.752,381.823 566.704,381.872 574.436,389.558 574.482,389.512 594.625,409.547 602.36,401.853 588.535,388.102      626.092,388.102    ",
    id: "svg_373",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "843.669,480.2 819.499,456.156 843.608,432.163 834.327,422.941 810.225,446.93 810.223,446.929      800.942,456.159 800.947,456.164 800.89,456.22 810.166,465.443 810.221,465.389 834.388,489.426    ",
    id: "svg_374",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "815.008,549.396 790.837,525.352 814.947,501.359 805.666,492.137 781.563,516.127      781.562,516.125 772.281,525.356 772.286,525.36 772.229,525.417 781.505,534.639 781.56,534.585 805.727,558.622    ",
    id: "svg_375",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "727.651,992.76 703.481,968.715 727.59,944.723 718.309,935.501 694.207,959.49 694.205,959.488      684.924,968.719 684.929,968.724 684.872,968.78 694.148,978.003 694.203,977.949 718.37,1001.986    ",
    id: "svg_376",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "73.108,688.466 48.937,664.421 73.046,640.429 63.766,631.207 39.663,655.196 39.662,655.194      30.381,664.425 30.386,664.43 30.329,664.486 39.605,673.709 39.66,673.655 63.826,697.692    ",
    id: "svg_377",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_378",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "351.175,706.733 418.007,675.922 387.005,742.396 384.386,709.364     ",
    id: "svg_379",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_380",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "630.938,717.868 697.77,687.057 666.768,753.531 664.149,720.499     ",
    id: "svg_381",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_382",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1116.643,1022.594 1183.476,991.782 1152.474,1058.256 1149.855,1025.224     ",
    id: "svg_383",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_384",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1006.962,304.704 1073.794,273.893 1042.792,340.366 1040.173,307.334     ",
    id: "svg_385",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_386",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1062.479,1088.318l0,0c0,-13.406 -10.966,-24.313 -24.444,-24.313c-13.479,0 -24.444,10.907 -24.444,24.313l0,0l-6.199,0l0,38.651l61.284,0l0,-38.651l-6.197,0zm-38.859,0c0,-7.906 6.467,-14.338 14.416,-14.338s14.416,6.432 14.416,14.338l0,0l-28.832,0l0,0zm17.688,18.241l0,11.115l-6.624,0l0,-11.118c-1.385,-1.013 -2.287,-2.641 -2.287,-4.483c0,-3.076 2.507,-5.569 5.6,-5.569c3.093,0 5.599,2.494 5.599,5.569c0,1.843 -0.902,3.472 -2.288,4.486z",
    id: "svg_387",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_388",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m282.51,333.118l0,0c0,-13.406 -10.966,-24.313 -24.444,-24.313c-13.479,0 -24.444,10.907 -24.444,24.313l0,0l-6.199,0l0,38.651l61.284,0l0,-38.651l-6.197,0zm-38.86,0c0,-7.906 6.467,-14.338 14.416,-14.338c7.949,0 14.416,6.432 14.416,14.338l0,0l-28.832,0l0,0zm17.688,18.241l0,11.115l-6.624,0l0,-11.118c-1.385,-1.013 -2.287,-2.641 -2.287,-4.483c0,-3.076 2.507,-5.569 5.6,-5.569c3.093,0 5.599,2.494 5.599,5.569c0,1.843 -0.902,3.472 -2.288,4.486z",
    id: "svg_389",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_390",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1235.313,606.703l0,0c0,-13.406 -10.966,-24.313 -24.444,-24.313c-13.479,0 -24.444,10.907 -24.444,24.313l0,0l-6.199,0l0,38.651l61.284,0l0,-38.651l-6.197,0zm-38.859,0c0,-7.906 6.467,-14.338 14.416,-14.338c7.949,0 14.416,6.432 14.416,14.338l0,0l-28.832,0l0,0zm17.688,18.241l0,11.115l-6.624,0l0,-11.118c-1.385,-1.013 -2.287,-2.641 -2.287,-4.483c0,-3.076 2.507,-5.569 5.6,-5.569c3.093,0 5.599,2.494 5.599,5.569c0,1.843 -0.902,3.472 -2.288,4.486z",
    id: "svg_391",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_392",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m793.67,205.894l0,0c0,-13.406 -10.966,-24.313 -24.444,-24.313c-13.479,0 -24.444,10.907 -24.444,24.313l0,0l-6.199,0l0,38.651l61.284,0l0,-38.651l-6.197,0zm-38.859,0c0,-7.906 6.467,-14.338 14.416,-14.338c7.949,0 14.416,6.432 14.416,14.338l0,0l-28.832,0l0,0zm17.688,18.242l0,11.116l-6.624,0l0,-11.118c-1.385,-1.013 -2.287,-2.641 -2.287,-4.483c0,-3.076 2.507,-5.569 5.6,-5.569c3.093,0 5.599,2.494 5.599,5.569c0,1.841 -0.903,3.471 -2.288,4.485z",
    id: "svg_393",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "811.858,749.717 811.801,749.66 811.805,749.656 802.525,740.425 802.524,740.427      778.421,716.437 769.14,725.659 793.25,749.652 769.079,773.696 778.36,782.922 802.527,758.885 802.581,758.939    ",
    id: "svg_394",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "663.271,440.498 663.214,440.441 663.218,440.437 653.938,431.206 653.937,431.208      629.833,407.219 620.553,416.441 644.662,440.433 620.491,464.478 629.772,473.704 653.94,449.667 653.994,449.721    ",
    id: "svg_395",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "302.224,1142.393 302.167,1142.336 302.171,1142.333 292.891,1133.102 292.89,1133.103      268.786,1109.114 259.506,1118.336 283.615,1142.329 259.444,1166.373 268.726,1175.599 292.893,1151.562 292.947,1151.616         ",
    id: "svg_396",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "501.528,300.937 501.471,300.88 501.475,300.876 492.195,291.645 492.194,291.647      468.091,267.658 458.81,276.88 482.92,300.872 458.749,324.916 468.03,334.143 492.197,310.105 492.252,310.16    ",
    id: "svg_397",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_398",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1019.779,498.597c-17.488,0 -31.664,10.627 -31.664,23.736c0,6.417 3.402,12.235 8.922,16.507l0.009,14.241l16.548,-7.468c2.001,0.297 4.067,0.456 6.184,0.456c17.488,0 31.664,-10.627 31.664,-23.736c0,-13.109 -14.176,-23.736 -31.663,-23.736zm-13.33,28.723c-2.461,0 -4.457,-1.985 -4.457,-4.433s1.996,-4.433 4.457,-4.433s4.457,1.985 4.457,4.433s-1.996,4.433 -4.457,4.433zm13.314,0c-2.461,0 -4.457,-1.985 -4.457,-4.433s1.996,-4.433 4.457,-4.433s4.457,1.985 4.457,4.433c0.001,2.448 -1.995,4.433 -4.457,4.433zm13.132,0c-2.462,0 -4.457,-1.985 -4.457,-4.433s1.995,-4.433 4.457,-4.433s4.457,1.985 4.457,4.433s-1.995,4.433 -4.457,4.433z",
    id: "svg_399",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_400",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m235.605,1061.676c-17.488,0 -31.664,10.627 -31.664,23.736c0,6.417 3.402,12.235 8.922,16.507l0.009,14.241l16.548,-7.468c2.001,0.297 4.067,0.456 6.184,0.456c17.488,0 31.664,-10.627 31.664,-23.736c0,-13.109 -14.176,-23.736 -31.663,-23.736zm-13.33,28.724c-2.461,0 -4.457,-1.985 -4.457,-4.433s1.996,-4.433 4.457,-4.433c2.461,0 4.457,1.985 4.457,4.433s-1.996,4.433 -4.457,4.433zm13.314,0c-2.461,0 -4.457,-1.985 -4.457,-4.433s1.996,-4.433 4.457,-4.433s4.457,1.985 4.457,4.433c0.001,2.448 -1.995,4.433 -4.457,4.433zm13.131,0c-2.462,0 -4.457,-1.985 -4.457,-4.433s1.995,-4.433 4.457,-4.433s4.457,1.985 4.457,4.433s-1.994,4.433 -4.457,4.433z",
    id: "svg_401",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_402",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m447.764,865.056c-17.488,0 -31.664,10.627 -31.664,23.736c0,6.417 3.402,12.235 8.922,16.507l0.009,14.241l16.548,-7.468c2.001,0.296 4.067,0.456 6.184,0.456c17.488,0 31.664,-10.627 31.664,-23.736c0.001,-13.11 -14.175,-23.736 -31.663,-23.736zm-13.33,28.723c-2.461,0 -4.457,-1.985 -4.457,-4.433s1.996,-4.433 4.457,-4.433s4.457,1.985 4.457,4.433s-1.995,4.433 -4.457,4.433zm13.314,0c-2.461,0 -4.457,-1.985 -4.457,-4.433s1.996,-4.433 4.457,-4.433s4.457,1.985 4.457,4.433c0.001,2.448 -1.995,4.433 -4.457,4.433zm13.132,0c-2.462,0 -4.457,-1.985 -4.457,-4.433s1.995,-4.433 4.457,-4.433s4.457,1.985 4.457,4.433s-1.995,4.433 -4.457,4.433z",
    id: "svg_403",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_404",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m725.893,727.636c-17.488,0 -31.664,10.627 -31.664,23.736c0,6.417 3.402,12.235 8.922,16.507l0.009,14.241l16.548,-7.468c2.001,0.297 4.067,0.456 6.184,0.456c17.488,0 31.664,-10.627 31.664,-23.736c0,-13.11 -14.176,-23.736 -31.663,-23.736zm-13.33,28.723c-2.461,0 -4.457,-1.985 -4.457,-4.433c0,-2.448 1.996,-4.433 4.457,-4.433s4.457,1.985 4.457,4.433c0,2.448 -1.996,4.433 -4.457,4.433zm13.314,0c-2.461,0 -4.457,-1.985 -4.457,-4.433c0,-2.448 1.996,-4.433 4.457,-4.433s4.457,1.985 4.457,4.433c0.001,2.448 -1.995,4.433 -4.457,4.433zm13.131,0c-2.462,0 -4.457,-1.985 -4.457,-4.433c0,-2.448 1.995,-4.433 4.457,-4.433s4.457,1.985 4.457,4.433c0,2.448 -1.995,4.433 -4.457,4.433z",
    id: "svg_405",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_406",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m1012.481,737.783c-15.32,0 -27.74,-12.354 -27.74,-27.593c0,-8.738 4.088,-16.522 10.461,-21.577c-16.61,0.617 -29.888,14.197 -29.888,30.869c0,17.064 13.909,30.897 31.065,30.897c11.12,0 20.869,-5.815 26.358,-14.553c-3.174,1.258 -6.631,1.957 -10.256,1.957z",
    id: "svg_407",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_408",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m603.122,591.922c-15.32,0 -27.74,-12.354 -27.74,-27.593c0,-8.738 4.088,-16.522 10.461,-21.577c-16.61,0.617 -29.888,14.197 -29.888,30.869c0,17.064 13.909,30.897 31.065,30.897c11.12,0 20.869,-5.815 26.358,-14.553c-3.174,1.259 -6.631,1.957 -10.256,1.957z",
    id: "svg_409",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_410",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m902.723,456.719c-15.32,0 -27.74,-12.354 -27.74,-27.593c0,-8.738 4.088,-16.522 10.461,-21.577c-16.61,0.617 -29.888,14.197 -29.888,30.869c0,17.064 13.909,30.897 31.065,30.897c11.12,0 20.869,-5.815 26.358,-14.553c-3.175,1.258 -6.632,1.957 -10.256,1.957z",
    id: "svg_411",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_412",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m413.506,904.377c-15.32,0 -27.74,-12.354 -27.74,-27.593c0,-8.738 4.088,-16.522 10.461,-21.577c-16.61,0.617 -29.888,14.197 -29.888,30.869c0,17.064 13.909,30.897 31.065,30.897c11.12,0 20.869,-5.815 26.358,-14.553c-3.175,1.259 -6.632,1.957 -10.256,1.957z",
    id: "svg_413",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m393.67,163.283l-0.035,0l0,35.638c-0.851,-0.145 -1.733,-0.221 -2.636,-0.221c-7.21,0 -13.055,4.849 -13.055,10.831s5.845,10.831 13.055,10.831c7.21,0 13.055,-4.849 13.055,-10.831c0,-0.006 -0.001,-0.012 -0.001,-0.018l0,-34.306l30.328,-6.24l0,23.119c-0.852,-0.145 -1.734,-0.221 -2.637,-0.221c-7.21,0 -13.055,4.849 -13.055,10.831s5.845,10.831 13.055,10.831c7.21,0 13.055,-4.849 13.055,-10.831l0,0l0,-35.873l0,-10.929l0,-2.232l-51.129,9.621z",
    id: "svg_414",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.017,519.445l-0.035,0l0,35.638c-0.851,-0.145 -1.733,-0.221 -2.636,-0.221c-7.21,0 -13.055,4.849 -13.055,10.831c0,5.982 5.845,10.831 13.055,10.831c7.21,0 13.055,-4.849 13.055,-10.831c0,-0.006 -0.001,-0.012 -0.001,-0.018l0,-34.306l30.328,-6.24l0,23.119c-0.852,-0.145 -1.734,-0.221 -2.637,-0.221c-7.21,0 -13.055,4.849 -13.055,10.831c0,5.982 5.845,10.831 13.055,10.831c7.21,0 13.055,-4.849 13.055,-10.831l0,0l0,-35.873l0,-10.929l0,-2.232l-51.129,9.621z",
    id: "svg_415",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1055.063,992.117l-0.035,0l0,35.638c-0.851,-0.145 -1.733,-0.221 -2.636,-0.221c-7.21,0 -13.055,4.849 -13.055,10.831s5.845,10.831 13.055,10.831s13.055,-4.849 13.055,-10.831c0,-0.006 -0.001,-0.012 -0.001,-0.018l0,-34.306l30.328,-6.24l0,23.119c-0.852,-0.145 -1.734,-0.221 -2.637,-0.221c-7.21,0 -13.055,4.849 -13.055,10.831s5.845,10.831 13.055,10.831c7.21,0 13.055,-4.849 13.055,-10.831l0,0l0,-35.873l0,-10.929l0,-2.232l-51.129,9.621z",
    id: "svg_416",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.193,322.972l-0.035,0l0,35.638c-0.851,-0.145 -1.733,-0.221 -2.636,-0.221c-7.21,0 -13.055,4.849 -13.055,10.831s5.845,10.831 13.055,10.831s13.055,-4.849 13.055,-10.831c0,-0.006 -0.001,-0.012 -0.001,-0.018l0,-34.306l30.328,-6.24l0,23.119c-0.852,-0.145 -1.734,-0.221 -2.637,-0.221c-7.21,0 -13.055,4.849 -13.055,10.831s5.845,10.831 13.055,10.831c7.21,0 13.055,-4.849 13.055,-10.831l0,0l0,-35.873l0,-10.929l0,-2.232l-51.129,9.621z",
    id: "svg_417",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_418",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m407.791,473.092l0,-0.014c0,0 -12.628,-12.546 -12.636,-12.552c-1.001,-0.996 -2.602,-0.975 -3.587,0.007l-5.813,5.805c-2.26,2.248 -5.173,0.253 -10.766,-4.283c-3.7,-3.001 -7.958,-7.037 -11.65,-11.587c-2.591,-3.192 -4.882,-6.545 -2.515,-8.898l0,0c0.006,-0.006 5.836,-5.79 5.835,-5.796l0.004,-0.012c1.046,-1.041 0.945,-2.635 -0.011,-3.586l0,-0.014c0,0 -12.993,-12.907 -13,-12.915c-1.001,-0.996 -2.602,-0.974 -3.587,0.007l-5.855,5.824c-2.412,3.003 -7.774,17.315 15.211,40.748c24.213,24.688 39.837,19.407 42.527,16.621c0,0 5.849,-5.749 5.849,-5.755l0.005,-0.012c1.047,-1.043 0.944,-2.636 -0.011,-3.588z",
    id: "svg_419",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_420",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1160.453,295.2l0,-0.014c0,0 -12.628,-12.546 -12.636,-12.552c-1.001,-0.996 -2.602,-0.975 -3.587,0.007l-5.813,5.805c-2.26,2.248 -5.173,0.253 -10.766,-4.283c-3.7,-3.001 -7.958,-7.037 -11.65,-11.587c-2.591,-3.192 -4.881,-6.545 -2.515,-8.898l0,0c0.006,-0.006 5.836,-5.79 5.835,-5.796l0.005,-0.012c1.046,-1.041 0.945,-2.635 -0.011,-3.586l0,-0.014c0,0 -12.993,-12.907 -13,-12.915c-1.001,-0.996 -2.602,-0.974 -3.587,0.007l-5.855,5.824c-2.412,3.003 -7.774,17.315 15.211,40.748c24.213,24.688 39.837,19.407 42.527,16.621c0,0 5.849,-5.749 5.849,-5.755l0.005,-0.012c1.046,-1.043 0.943,-2.636 -0.012,-3.588z",
    id: "svg_421",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_422",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m789.296,93.179l0,-0.014c0,0 -12.628,-12.546 -12.636,-12.552c-1.001,-0.996 -2.602,-0.975 -3.587,0.007l-5.813,5.805c-2.26,2.248 -5.173,0.253 -10.766,-4.283c-3.7,-3.001 -7.958,-7.037 -11.65,-11.587c-2.591,-3.192 -4.882,-6.545 -2.515,-8.898l0,0c0.006,-0.006 5.836,-5.79 5.835,-5.796l0.005,-0.012c1.046,-1.041 0.945,-2.635 -0.011,-3.586l0,-0.014c0,0 -12.993,-12.907 -13,-12.915c-1.001,-0.996 -2.602,-0.974 -3.587,0.007l-5.855,5.824c-2.412,3.003 -7.774,17.315 15.211,40.748c24.213,24.688 39.837,19.407 42.527,16.621c0,0 5.849,-5.749 5.849,-5.755l0.005,-0.012c1.046,-1.043 0.943,-2.636 -0.012,-3.588z",
    id: "svg_423",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_424",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1093.653,233.799l0,-0.014c0,0 -12.628,-12.546 -12.636,-12.552c-1.001,-0.996 -2.602,-0.975 -3.587,0.007l-5.813,5.805c-2.26,2.248 -5.173,0.253 -10.766,-4.283c-3.7,-3.001 -7.958,-7.037 -11.65,-11.587c-2.591,-3.192 -4.882,-6.545 -2.515,-8.898l0,0c0.006,-0.006 5.836,-5.79 5.835,-5.796l0.004,-0.012c1.046,-1.041 0.945,-2.635 -0.01,-3.586l0,-0.014c0,0 -12.993,-12.907 -13,-12.915c-1.001,-0.996 -2.602,-0.974 -3.587,0.007l-5.855,5.824c-2.412,3.003 -7.774,17.315 15.211,40.748c24.213,24.688 39.837,19.407 42.527,16.621c0,0 5.849,-5.749 5.849,-5.755l0.005,-0.012c1.046,-1.042 0.943,-2.636 -0.012,-3.588z",
    id: "svg_425",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_426",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m284.602,595.658c-13.804,0 -24.995,11.131 -24.995,24.862c0,23.223 24.995,41.785 24.995,41.785s24.995,-18.56 24.995,-41.785c0.001,-13.732 -11.191,-24.863 -24.995,-24.862zm0.001,35.846c-6.099,0 -11.044,-4.918 -11.044,-10.985c0,-6.067 4.945,-10.985 11.044,-10.985c6.099,0 11.044,4.918 11.044,10.985c0,6.067 -4.945,10.985 -11.044,10.985z",
    id: "svg_427",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_428",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m776.619,1229.29c-13.804,0 -24.995,11.131 -24.995,24.862c0,23.224 24.995,41.785 24.995,41.785s24.995,-18.56 24.995,-41.785c0.001,-13.731 -11.191,-24.862 -24.995,-24.862zm0.001,35.846c-6.099,0 -11.044,-4.918 -11.044,-10.985c0,-6.067 4.945,-10.985 11.044,-10.985s11.044,4.918 11.044,10.985c0,6.067 -4.945,10.985 -11.044,10.985z",
    id: "svg_429",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_430",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m853.919,705.631c-13.804,0 -24.995,11.131 -24.995,24.861c0,23.224 24.995,41.785 24.995,41.785s24.996,-18.56 24.996,-41.785c0,-13.731 -11.192,-24.862 -24.996,-24.861zm0.001,35.846c-6.099,0 -11.044,-4.918 -11.044,-10.985c0,-6.067 4.944,-10.985 11.044,-10.985s11.044,4.918 11.044,10.985c0,6.067 -4.945,10.985 -11.044,10.985z",
    id: "svg_431",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_432",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m705.957,397.256c-13.804,0 -24.995,11.131 -24.995,24.861c0,23.223 24.995,41.785 24.995,41.785s24.995,-18.56 24.995,-41.785c0.001,-13.73 -11.19,-24.861 -24.995,-24.861zm0.001,35.847c-6.099,0 -11.044,-4.918 -11.044,-10.985c0,-6.067 4.945,-10.985 11.044,-10.985s11.044,4.918 11.044,10.985c0,6.067 -4.944,10.985 -11.044,10.985z",
    id: "svg_433",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_434",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_435",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1135.233,381.836c4.409,-4.386 -1.69,-10.12 -6.044,-5.789l-16.078,15.991l-36.832,-9.684l-6.14,6.107l30.358,15.903l-12.278,12.212l-9.545,-1.165l-4.856,4.83l10.829,5.663l5.694,10.771l4.856,-4.83l-1.116,-9.438l12.278,-12.212l15.645,29.997l6.14,-6.107l-9.321,-35.893l16.41,-16.356z",
    id: "svg_436",
    fill: "#191a19",
    stroke: "null"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_437",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_438",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m464.365,442.835c4.409,-4.386 -1.69,-10.12 -6.044,-5.789l-16.078,15.991l-36.832,-9.684l-6.14,6.107l30.358,15.903l-12.278,12.212l-9.545,-1.165l-4.856,4.83l10.829,5.663l5.694,10.771l4.856,-4.83l-1.116,-9.438l12.278,-12.212l15.645,29.997l6.14,-6.107l-9.321,-35.893l16.41,-16.356z",
    id: "svg_439",
    fill: "#191a19",
    stroke: "null"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_440",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_441",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1190.844,883.793c4.409,-4.386 -1.69,-10.12 -6.044,-5.789l-16.078,15.991l-36.832,-9.684l-6.14,6.107l30.358,15.903l-12.278,12.212l-9.545,-1.165l-4.856,4.83l10.829,5.663l5.694,10.771l4.856,-4.83l-1.116,-9.438l12.278,-12.212l15.645,29.997l6.14,-6.107l-9.321,-35.893l16.41,-16.356z",
    id: "svg_442",
    fill: "#191a19",
    stroke: "null"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_443",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_444",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m593.929,939.859c4.409,-4.386 -1.69,-10.12 -6.044,-5.789l-16.078,15.991l-36.832,-9.684l-6.14,6.107l30.358,15.903l-12.278,12.212l-9.545,-1.165l-4.856,4.83l10.829,5.663l5.694,10.771l4.856,-4.831l-1.116,-9.438l12.278,-12.212l15.645,29.997l6.14,-6.107l-9.321,-35.893l16.41,-16.355z",
    id: "svg_445",
    fill: "#191a19",
    stroke: "null"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "455.01,597.025 434.026,597.025 434.026,576.147 420.288,576.147 420.288,597.025 399.297,597.025      399.297,610.69 420.288,610.69 420.288,631.561 434.026,631.561 434.026,610.69 455.01,610.69    ",
    id: "svg_446",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.571,656.912 224.587,656.912 224.587,636.034 210.849,636.034 210.849,656.912 189.858,656.912      189.858,670.577 210.849,670.577 210.849,691.448 224.587,691.448 224.587,670.577 245.571,670.577    ",
    id: "svg_447",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1019.334,797.943 998.351,797.943 998.351,777.065 984.612,777.065 984.612,797.943 963.622,797.943      963.622,811.608 984.612,811.608 984.612,832.479 998.351,832.479 998.351,811.608 1019.334,811.608    ",
    id: "svg_448",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.168,1094.023 447.184,1094.023 447.184,1073.144 433.446,1073.144 433.446,1094.023 412.455,1094.023      412.455,1107.687 433.446,1107.687 433.446,1128.558 447.184,1128.558 447.184,1107.687 468.168,1107.687    ",
    id: "svg_449",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_450",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_451",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m317.633,319.304c0,17.291 14.093,31.309 31.478,31.309c17.384,0 31.478,-14.018 31.478,-31.309c0,-9.013 -3.834,-17.129 -9.961,-22.842l-8.003,8.497c3.851,3.592 6.265,8.693 6.265,14.346c0,10.847 -8.873,19.672 -19.778,19.672c-10.906,0 -19.778,-8.825 -19.778,-19.672",
    id: "svg_452",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_453",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m368.889,319.304c0,10.847 -8.872,19.672 -19.778,19.672c-10.905,0 -19.778,-8.825 -19.778,-19.672c0,-5.653 2.413,-10.754 6.265,-14.346l-8.003,-8.496c-6.127,5.713 -9.961,13.83 -9.961,22.842c0,17.291 14.094,31.309 31.478,31.309c17.385,0 31.478,-14.018 31.478,-31.309",
    id: "svg_454",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 343.547,
    y: 286.736,
    fill: "#191a19",
    width: 11.129,
    height: 34.122,
    id: "svg_455",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_456",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_457",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m300.42,1009.667c0,17.291 14.093,31.309 31.478,31.309c17.384,0 31.478,-14.018 31.478,-31.309c0,-9.013 -3.834,-17.129 -9.961,-22.842l-8.003,8.497c3.851,3.592 6.265,8.693 6.265,14.346c0,10.847 -8.873,19.672 -19.778,19.672c-10.906,0 -19.778,-8.825 -19.778,-19.672",
    id: "svg_458",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_459",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m351.676,1009.667c0,10.847 -8.872,19.672 -19.778,19.672c-10.905,0 -19.778,-8.825 -19.778,-19.672c0,-5.653 2.413,-10.754 6.265,-14.346l-8.003,-8.496c-6.127,5.713 -9.961,13.83 -9.961,22.842c0,17.291 14.094,31.309 31.478,31.309c17.385,0 31.478,-14.018 31.478,-31.309",
    id: "svg_460",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 326.334,
    y: 977.099,
    fill: "#191a19",
    width: 11.129,
    height: 34.122,
    id: "svg_461",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_462",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_463",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m580.795,660.976c0,17.291 14.093,31.309 31.478,31.309c17.384,0 31.478,-14.018 31.478,-31.309c0,-9.013 -3.834,-17.129 -9.961,-22.842l-8.003,8.497c3.851,3.592 6.265,8.693 6.265,14.346c0,10.847 -8.873,19.672 -19.778,19.672c-10.906,0 -19.778,-8.825 -19.778,-19.672",
    id: "svg_464",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_465",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m632.051,660.976c0,10.847 -8.872,19.672 -19.778,19.672c-10.905,0 -19.778,-8.825 -19.778,-19.672c0,-5.653 2.414,-10.754 6.265,-14.346l-8.003,-8.496c-6.127,5.713 -9.961,13.83 -9.961,22.842c0,17.291 14.094,31.309 31.478,31.309c17.385,0 31.478,-14.018 31.478,-31.309",
    id: "svg_466",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 606.709,
    y: 628.408,
    fill: "#191a19",
    width: 11.129,
    height: 34.122,
    id: "svg_467",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_468",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_469",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m476.392,609.758c0,17.291 14.093,31.309 31.478,31.309c17.384,0 31.478,-14.018 31.478,-31.309c0,-9.013 -3.834,-17.129 -9.961,-22.842l-8.003,8.497c3.851,3.592 6.265,8.693 6.265,14.346c0,10.847 -8.873,19.672 -19.778,19.672c-10.906,0 -19.778,-8.825 -19.778,-19.672",
    id: "svg_470",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_471",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m527.648,609.758c0,10.847 -8.872,19.672 -19.778,19.672c-10.905,0 -19.778,-8.825 -19.778,-19.672c0,-5.653 2.413,-10.754 6.265,-14.346l-8.003,-8.496c-6.127,5.713 -9.961,13.83 -9.961,22.842c0,17.291 14.094,31.309 31.478,31.309c17.385,0 31.478,-14.018 31.478,-31.309",
    id: "svg_472",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 502.306,
    y: 577.19,
    fill: "#191a19",
    width: 11.129,
    height: 34.122,
    id: "svg_473",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m529.231,321.016c-17.385,0 -31.478,14.018 -31.478,31.309c0,17.291 14.093,31.309 31.478,31.309c9.061,0 17.221,-3.814 22.965,-9.908l-8.542,-7.96c-3.612,3.831 -8.74,6.231 -14.423,6.231c-10.906,0 -19.778,-8.825 -19.778,-19.672c0,-10.847 8.872,-19.672 19.778,-19.672c7.561,0 14.139,4.245 17.466,10.463l-9.206,6.887l25.163,7.221l0.004,-26.05l-6.534,4.889c-5.524,-9.02 -15.498,-15.047 -26.893,-15.047z",
    id: "svg_474",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.047,609.748c-17.385,0 -31.478,14.018 -31.478,31.309c0,17.291 14.093,31.309 31.478,31.309c9.061,0 17.221,-3.814 22.965,-9.908l-8.542,-7.96c-3.612,3.831 -8.74,6.231 -14.423,6.231c-10.906,0 -19.778,-8.825 -19.778,-19.672c0,-10.847 8.872,-19.672 19.778,-19.672c7.561,0 14.139,4.245 17.466,10.463l-9.206,6.887l25.163,7.221l0.004,-26.05l-6.534,4.889c-5.524,-9.02 -15.498,-15.047 -26.893,-15.047z",
    id: "svg_475",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.922,235.293c-17.385,0 -31.478,14.018 -31.478,31.309c0,17.291 14.093,31.309 31.478,31.309c9.061,0 17.221,-3.814 22.965,-9.908l-8.542,-7.96c-3.612,3.831 -8.74,6.231 -14.423,6.231c-10.906,0 -19.778,-8.825 -19.778,-19.672c0,-10.847 8.872,-19.672 19.778,-19.672c7.561,0 14.139,4.245 17.466,10.463l-9.206,6.887l25.163,7.221l0.004,-26.05l-6.534,4.889c-5.524,-9.02 -15.498,-15.047 -26.893,-15.047z",
    id: "svg_476",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m918.507,766.337c-17.385,0 -31.478,14.018 -31.478,31.309c0,17.291 14.093,31.309 31.478,31.309c9.061,0 17.221,-3.814 22.965,-9.908l-8.542,-7.96c-3.612,3.831 -8.74,6.231 -14.423,6.231c-10.906,0 -19.778,-8.825 -19.778,-19.672c0,-10.847 8.872,-19.672 19.778,-19.672c7.561,0 14.139,4.245 17.466,10.463l-9.206,6.887l25.163,7.221l0.004,-26.05l-6.534,4.889c-5.524,-9.02 -15.499,-15.047 -26.893,-15.047z",
    id: "svg_477",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_478",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "276.293,439.013 244.006,439.013 255.451,450.397 241.236,464.536 251.042,474.29 265.257,460.15       276.293,471.127     ",
    id: "svg_479",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.291,472.26 222.473,484.014 209.438,471.048 209.438,505.509 244.085,505.509 232.28,493.768       244.097,482.014     ",
    id: "svg_480",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_481",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "569.688,631.397 537.401,631.397 548.847,642.781 534.631,656.92 544.437,666.674 558.653,652.534       569.688,663.511     ",
    id: "svg_482",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "527.686,664.645 515.869,676.398 502.833,663.432 502.833,697.894 537.48,697.894 525.675,686.152       537.493,674.398     ",
    id: "svg_483",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_484",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "895.476,836.747 863.188,836.747 874.634,848.131 860.418,862.271 870.224,872.024 884.44,857.885       895.476,868.861     ",
    id: "svg_485",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "853.473,869.995 841.656,881.749 828.62,868.782 828.62,903.244 863.268,903.244 851.463,891.502       863.28,879.749     ",
    id: "svg_486",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_487",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1270.505,512.115 1238.218,512.115 1249.664,523.499 1235.448,537.639 1245.254,547.392 1259.47,533.253       1270.505,544.229     ",
    id: "svg_488",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1228.503,545.363 1216.686,557.117 1203.65,544.15 1203.65,578.612 1238.297,578.612 1226.492,566.87       1238.309,555.117     ",
    id: "svg_489",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "932.219,325.118 924.487,317.432 924.446,317.473 904.306,297.441 896.571,305.135 910.395,318.885      872.83,318.885 872.83,331.375 910.476,331.375 896.616,345.17 904.348,352.855 924.443,332.857 924.445,332.859 932.18,325.166      932.175,325.161    ",
    id: "svg_490",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.392,1034.376 196.66,1026.69 196.619,1026.731 176.479,1006.7 168.744,1014.393 182.568,1028.143      145.003,1028.143 145.003,1040.633 182.649,1040.633 168.789,1054.428 176.521,1062.114 196.616,1042.115 196.618,1042.117      204.353,1034.424 204.348,1034.419    ",
    id: "svg_491",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.352,965.891 405.62,958.205 405.579,958.246 385.439,938.214 377.705,945.907 391.529,959.658      353.964,959.658 353.964,972.148 391.609,972.148 377.749,985.942 385.481,993.628 405.576,973.629 405.578,973.632      413.313,965.939 413.308,965.934    ",
    id: "svg_492",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "780.402,479.494 772.67,471.808 772.629,471.849 752.489,451.817 744.754,459.51 758.578,473.261      721.013,473.261 721.013,485.751 758.659,485.751 744.799,499.546 752.53,507.231 772.625,487.233 772.628,487.235      780.363,479.542 780.358,479.537    ",
    id: "svg_493",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_494",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.257,
    cy: 559.193,
    rx: 4.704,
    ry: 4.679,
    id: "svg_495",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.289,543.002c-11.588,0 -20.983,9.344 -20.983,20.87s9.394,20.87 20.983,20.87c11.589,0 20.983,-9.344 20.983,-20.87s-9.395,-20.87 -20.983,-20.87zm0,35.886c-8.325,0 -15.097,-6.736 -15.097,-15.016s6.772,-15.016 15.097,-15.016s15.097,6.736 15.097,15.016s-6.773,15.016 -15.097,15.016z",
    id: "svg_496",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.592,533.341c-16.923,0 -30.642,13.646 -30.642,30.478c0,16.832 13.719,30.478 30.642,30.478c16.923,0 30.642,-13.646 30.642,-30.478c0,-16.832 -13.72,-30.478 -30.642,-30.478zm0,55.102c-13.651,0 -24.756,-11.046 -24.756,-24.624s11.106,-24.624 24.757,-24.624c13.651,0 24.756,11.046 24.756,24.624s-11.107,24.624 -24.757,24.624z",
    id: "svg_497",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_498",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 585.788,
    cy: 151.144,
    rx: 4.704,
    ry: 4.679,
    id: "svg_499",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m580.819,134.954c-11.588,0 -20.983,9.344 -20.983,20.87s9.394,20.87 20.983,20.87s20.982,-9.344 20.982,-20.87s-9.394,-20.87 -20.982,-20.87zm0,35.886c-8.325,0 -15.097,-6.736 -15.097,-15.016s6.772,-15.016 15.097,-15.016s15.097,6.736 15.097,15.016s-6.772,15.016 -15.097,15.016z",
    id: "svg_500",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m581.122,125.293c-16.923,0 -30.642,13.646 -30.642,30.478s13.719,30.478 30.642,30.478c16.923,0 30.642,-13.646 30.642,-30.478s-13.719,-30.478 -30.642,-30.478zm0,55.101c-13.651,0 -24.756,-11.046 -24.756,-24.624c0,-13.578 11.106,-24.624 24.756,-24.624c13.651,0 24.757,11.046 24.757,24.624c0,13.578 -11.106,24.624 -24.757,24.624z",
    id: "svg_501",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_502",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 478.523,
    cy: 772.653,
    rx: 4.704,
    ry: 4.679,
    id: "svg_503",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473.555,756.462c-11.588,0 -20.982,9.344 -20.982,20.87c0,11.526 9.394,20.87 20.982,20.87c11.589,0 20.983,-9.344 20.983,-20.87c0,-11.526 -9.395,-20.87 -20.983,-20.87zm0,35.886c-8.325,0 -15.097,-6.736 -15.097,-15.016s6.772,-15.016 15.097,-15.016c8.325,0 15.097,6.736 15.097,15.016s-6.772,15.016 -15.097,15.016z",
    id: "svg_504",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473.858,746.801c-16.923,0 -30.642,13.646 -30.642,30.478c0,16.832 13.719,30.478 30.642,30.478c16.923,0 30.642,-13.646 30.642,-30.478c0,-16.832 -13.719,-30.478 -30.642,-30.478zm0,55.102c-13.651,0 -24.757,-11.046 -24.757,-24.624c0,-13.578 11.106,-24.624 24.757,-24.624c13.651,0 24.756,11.046 24.756,24.624c0.001,13.577 -11.105,24.624 -24.756,24.624z",
    id: "svg_505",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_506",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1259.403,
    cy: 705.352,
    rx: 4.704,
    ry: 4.679,
    id: "svg_507",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1254.435,689.161c-11.588,0 -20.983,9.344 -20.983,20.87c0,11.526 9.394,20.87 20.983,20.87c11.589,0 20.983,-9.344 20.983,-20.87c-0.001,-11.526 -9.395,-20.87 -20.983,-20.87zm0,35.886c-8.325,0 -15.097,-6.736 -15.097,-15.016s6.772,-15.016 15.097,-15.016s15.097,6.736 15.097,15.016s-6.773,15.016 -15.097,15.016z",
    id: "svg_508",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1254.738,679.5c-16.923,0 -30.642,13.646 -30.642,30.478c0,16.832 13.719,30.478 30.642,30.478c16.923,0 30.642,-13.646 30.642,-30.478c0,-16.832 -13.719,-30.478 -30.642,-30.478zm0,55.102c-13.651,0 -24.756,-11.046 -24.756,-24.624s11.106,-24.624 24.756,-24.624c13.651,0 24.756,11.046 24.756,24.624s-11.106,24.624 -24.756,24.624z",
    id: "svg_509",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_510",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "433.915,732.284 400.58,732.285 400.579,741.485 417.112,741.485 399.316,759.186       406.823,766.653 424.616,748.955 424.62,765.453 433.862,765.447 433.853,741.485 433.913,741.485     ",
    id: "svg_511",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "415.195,785.43 378.151,785.43 378.151,750.903 391.33,750.903 391.33,741.482 368.68,741.482       368.68,745.255 368.68,750.903 368.68,785.43 368.68,793.465 368.68,794.85 415.195,794.85 424.666,794.85 424.666,785.43       424.666,774.381 415.195,774.381     ",
    id: "svg_512",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_513",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "98.545,731.859 65.209,731.861 65.209,741.061 81.742,741.061 63.946,758.762 71.453,766.229       89.245,748.531 89.25,765.029 98.491,765.022 98.483,741.06 98.543,741.06     ",
    id: "svg_514",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "79.824,785.006 42.781,785.006 42.781,750.479 55.96,750.479 55.96,741.058 33.31,741.058       33.31,744.831 33.31,750.479 33.31,785.006 33.31,793.041 33.31,794.426 79.824,794.426 89.296,794.426 89.296,785.006       89.296,773.956 79.824,773.956     ",
    id: "svg_515",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_516",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "770.598,320.409 737.262,320.41 737.262,329.61 753.795,329.61 735.999,347.311       743.506,354.778 761.299,337.08 761.303,353.578 770.545,353.572 770.536,329.61 770.596,329.61     ",
    id: "svg_517",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "751.877,373.555 714.834,373.555 714.834,339.028 728.013,339.028 728.013,329.607       705.363,329.607 705.363,333.38 705.363,339.028 705.363,373.555 705.363,381.59 705.363,382.975 751.877,382.975       761.349,382.975 761.349,373.555 761.349,362.506 751.877,362.506     ",
    id: "svg_518",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_519",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "557.445,873.66 524.11,873.662 524.109,882.861 540.642,882.861 522.846,900.562       530.353,908.029 548.146,890.332 548.15,906.83 557.392,906.823 557.384,882.861 557.443,882.861     ",
    id: "svg_520",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#191a19",
    points: "538.725,926.806 501.681,926.806 501.681,892.279 514.86,892.279 514.86,882.859       492.21,882.859 492.21,886.631 492.21,892.279 492.21,926.806 492.21,934.841 492.21,936.227 538.725,936.227 548.196,936.227       548.196,926.806 548.196,915.757 538.725,915.757     ",
    id: "svg_521",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_522",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "793.858,933.72 775.448,933.72 773.937,929.976 758.514,929.976 757.003,933.72 738.594,933.72       737.479,942.328 794.972,942.328     ",
    id: "svg_523",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "780.35,986.329 776.319,986.329 776.319,945.391 768.24,945.391 768.24,986.329 764.21,986.329 764.21,945.391       755.577,945.391 755.577,986.329 751.547,986.329 751.547,945.391 741.164,945.391 743.95,992.91 788.5,992.91 791.843,945.391       780.35,945.391     ",
    id: "svg_524",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_525",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "950.812,696.289 932.402,696.289 930.891,692.545 915.467,692.545 913.957,696.289 895.547,696.289       894.433,704.898 951.926,704.898     ",
    id: "svg_526",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "937.304,748.898 933.273,748.898 933.273,707.96 925.194,707.96 925.194,748.898 921.164,748.898       921.164,707.96 912.531,707.96 912.531,748.898 908.501,748.898 908.501,707.96 898.118,707.96 900.904,755.479       945.454,755.479 948.797,707.96 937.304,707.96     ",
    id: "svg_527",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_528",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "151.089,393.488 132.679,393.488 131.168,389.744 115.744,389.744 114.234,393.488 95.824,393.488       94.71,402.097 152.203,402.097     ",
    id: "svg_529",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.581,446.098 133.55,446.098 133.55,405.159 125.471,405.159 125.471,446.098 121.441,446.098       121.441,405.159 112.808,405.159 112.808,446.098 108.778,446.098 108.778,405.159 98.395,405.159 101.181,452.678       145.731,452.678 149.074,405.159 137.581,405.159     ",
    id: "svg_530",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_531",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1123.093,307.406 1104.683,307.406 1103.172,303.662 1087.748,303.662 1086.237,307.406 1067.828,307.406       1066.714,316.014 1124.207,316.014     ",
    id: "svg_532",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1109.584,360.015 1105.554,360.015 1105.554,319.077 1097.475,319.077 1097.475,360.015 1093.445,360.015       1093.445,319.077 1084.812,319.077 1084.812,360.015 1080.782,360.015 1080.782,319.077 1070.399,319.077 1073.185,366.596       1117.735,366.596 1121.078,319.077 1109.584,319.077     ",
    id: "svg_533",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_534",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_9_",
    d: "m555.418,1273.616l-14.937,-14.864c2.015,-3.3 3.192,-7.162 3.192,-11.301c0,-12.077 -9.828,-21.866 -21.977,-21.866c-12.135,0 -21.97,9.789 -21.97,21.866c0,12.07 9.842,21.845 21.977,21.845c4.161,0 8.044,-1.172 11.362,-3.175l14.95,14.879l7.403,-7.384zm-47.307,-26.164c0.014,-7.466 6.092,-13.512 13.599,-13.526c7.5,0.014 13.578,6.06 13.585,13.526c-0.014,7.46 -6.092,13.512 -13.592,13.512c-7.514,0 -13.578,-6.053 -13.592,-13.512z",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_535",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_8_",
    d: "m190.192,918.807l-14.937,-14.864c2.015,-3.3 3.192,-7.162 3.192,-11.301c0,-12.077 -9.828,-21.866 -21.977,-21.866c-12.135,0 -21.97,9.789 -21.97,21.866c0,12.07 9.842,21.845 21.977,21.845c4.161,0 8.044,-1.171 11.361,-3.175l14.951,14.878l7.403,-7.383zm-47.307,-26.165c0.014,-7.466 6.092,-13.512 13.599,-13.526c7.5,0.014 13.578,6.06 13.585,13.526c-0.014,7.46 -6.092,13.512 -13.592,13.512c-7.514,0 -13.578,-6.052 -13.592,-13.512z",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_536",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_7_",
    d: "m508.175,740.992l-14.937,-14.864c2.015,-3.3 3.192,-7.162 3.192,-11.301c0,-12.077 -9.828,-21.866 -21.977,-21.866c-12.135,0 -21.97,9.789 -21.97,21.866c0,12.07 9.842,21.845 21.977,21.845c4.161,0 8.044,-1.171 11.361,-3.175l14.951,14.878l7.403,-7.383zm-47.306,-26.165c0.014,-7.466 6.092,-13.512 13.599,-13.526c7.5,0.014 13.578,6.06 13.585,13.526c-0.014,7.46 -6.092,13.512 -13.592,13.512c-7.515,0 -13.579,-6.052 -13.592,-13.512z",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_537",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_6_",
    d: "m111.866,868.965l-14.937,-14.864c2.015,-3.3 3.192,-7.162 3.192,-11.301c0,-12.077 -9.828,-21.866 -21.977,-21.866c-12.135,0 -21.97,9.789 -21.97,21.866c0,12.07 9.842,21.845 21.977,21.845c4.161,0 8.044,-1.171 11.361,-3.175l14.951,14.878l7.403,-7.383zm-47.307,-26.164c0.014,-7.466 6.092,-13.512 13.599,-13.526c7.5,0.014 13.578,6.06 13.585,13.526c-0.014,7.46 -6.092,13.512 -13.592,13.512c-7.514,0 -13.578,-6.053 -13.592,-13.512z",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_538",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 657.148,
    y1: 360.966,
    x2: 657.148,
    y2: 394.14,
    id: "svg_539",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 657.148,
    y1: 380.485,
    x2: 667.957,
    y2: 386.692,
    id: "svg_540",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 657.148,
    y1: 360.966,
    x2: 657.148,
    y2: 327.793,
    id: "svg_541",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 657.148,
    y1: 341.448,
    x2: 646.339,
    y2: 335.241,
    id: "svg_542",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 657.148,
    y1: 341.448,
    x2: 667.957,
    y2: 335.241,
    id: "svg_543",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 657.148,
    y1: 380.485,
    x2: 646.338,
    y2: 386.692,
    id: "svg_544",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 657.148,
    y1: 360.966,
    x2: 628.264,
    y2: 377.553,
    id: "svg_545",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 640.153,
    y1: 370.725,
    x2: 640.153,
    y2: 383.14,
    id: "svg_546",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 657.148,
    y1: 360.966,
    x2: 686.032,
    y2: 344.379,
    id: "svg_547",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 674.142,
    y1: 351.207,
    x2: 674.142,
    y2: 338.794,
    id: "svg_548",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 674.142,
    y1: 351.207,
    x2: 684.952,
    y2: 357.415,
    id: "svg_549",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 640.153,
    y1: 370.725,
    x2: 629.344,
    y2: 364.518,
    id: "svg_550",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 657.148,
    y1: 360.966,
    x2: 628.264,
    y2: 344.378,
    id: "svg_551",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 640.153,
    y1: 351.207,
    x2: 629.344,
    y2: 357.414,
    id: "svg_552",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 657.148,
    y1: 360.966,
    x2: 686.032,
    y2: 377.552,
    id: "svg_553",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 674.142,
    y1: 370.725,
    x2: 684.951,
    y2: 364.518,
    id: "svg_554",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 674.142,
    y1: 370.725,
    x2: 674.142,
    y2: 383.14,
    id: "svg_555",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 640.153,
    y1: 351.207,
    x2: 640.153,
    y2: 338.792,
    id: "svg_556",
    stroke: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_557",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 883.395,
    y1: 1208.902,
    x2: 883.395,
    y2: 1242.075,
    id: "svg_558",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 883.395,
    y1: 1228.42,
    x2: 894.204,
    y2: 1234.627,
    id: "svg_559",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 883.395,
    y1: 1208.902,
    x2: 883.395,
    y2: 1175.728,
    id: "svg_560",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 883.395,
    y1: 1189.383,
    x2: 872.586,
    y2: 1183.177,
    id: "svg_561",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 883.395,
    y1: 1189.383,
    x2: 894.205,
    y2: 1183.177,
    id: "svg_562",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 883.395,
    y1: 1228.42,
    x2: 872.586,
    y2: 1234.627,
    id: "svg_563",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 883.395,
    y1: 1208.902,
    x2: 854.511,
    y2: 1225.489,
    id: "svg_564",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 866.401,
    y1: 1218.661,
    x2: 866.401,
    y2: 1231.076,
    id: "svg_565",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 883.395,
    y1: 1208.902,
    x2: 912.279,
    y2: 1192.315,
    id: "svg_566",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 900.39,
    y1: 1199.143,
    x2: 900.39,
    y2: 1186.729,
    id: "svg_567",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 900.39,
    y1: 1199.143,
    x2: 911.199,
    y2: 1205.35,
    id: "svg_568",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 866.401,
    y1: 1218.661,
    x2: 855.592,
    y2: 1212.454,
    id: "svg_569",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 883.395,
    y1: 1208.901,
    x2: 854.511,
    y2: 1192.314,
    id: "svg_570",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 866.401,
    y1: 1199.142,
    x2: 855.592,
    y2: 1205.349,
    id: "svg_571",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 883.395,
    y1: 1208.901,
    x2: 912.279,
    y2: 1225.488,
    id: "svg_572",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 900.39,
    y1: 1218.66,
    x2: 911.198,
    y2: 1212.453,
    id: "svg_573",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 900.39,
    y1: 1218.66,
    x2: 900.39,
    y2: 1231.075,
    id: "svg_574",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 866.401,
    y1: 1199.142,
    x2: 866.401,
    y2: 1186.728,
    id: "svg_575",
    stroke: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_576",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 320.565,
    y1: 485.678,
    x2: 320.565,
    y2: 518.851,
    id: "svg_577",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 320.565,
    y1: 505.196,
    x2: 331.374,
    y2: 511.403,
    id: "svg_578",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 320.565,
    y1: 485.678,
    x2: 320.565,
    y2: 452.504,
    id: "svg_579",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 320.565,
    y1: 466.159,
    x2: 309.756,
    y2: 459.952,
    id: "svg_580",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 320.565,
    y1: 466.159,
    x2: 331.374,
    y2: 459.952,
    id: "svg_581",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 320.565,
    y1: 505.196,
    x2: 309.756,
    y2: 511.403,
    id: "svg_582",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 320.565,
    y1: 485.678,
    x2: 291.681,
    y2: 502.265,
    id: "svg_583",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 303.57,
    y1: 495.436,
    x2: 303.57,
    y2: 507.851,
    id: "svg_584",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 320.565,
    y1: 485.678,
    x2: 349.449,
    y2: 469.09,
    id: "svg_585",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 337.56,
    y1: 475.919,
    x2: 337.56,
    y2: 463.505,
    id: "svg_586",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 337.56,
    y1: 475.919,
    x2: 348.369,
    y2: 482.126,
    id: "svg_587",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 303.57,
    y1: 495.436,
    x2: 292.762,
    y2: 489.23,
    id: "svg_588",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 320.565,
    y1: 485.677,
    x2: 291.681,
    y2: 469.089,
    id: "svg_589",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 303.57,
    y1: 475.918,
    x2: 292.762,
    y2: 482.125,
    id: "svg_590",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 320.565,
    y1: 485.677,
    x2: 349.449,
    y2: 502.264,
    id: "svg_591",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 337.56,
    y1: 495.436,
    x2: 348.368,
    y2: 489.229,
    id: "svg_592",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 337.56,
    y1: 495.436,
    x2: 337.56,
    y2: 507.851,
    id: "svg_593",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 303.57,
    y1: 475.918,
    x2: 303.57,
    y2: 463.504,
    id: "svg_594",
    stroke: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_595",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 1193.196,
    y1: 809.192,
    x2: 1193.196,
    y2: 842.366,
    id: "svg_596",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 1193.196,
    y1: 828.71,
    x2: 1204.005,
    y2: 834.917,
    id: "svg_597",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 1193.196,
    y1: 809.192,
    x2: 1193.196,
    y2: 776.018,
    id: "svg_598",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 1193.196,
    y1: 789.673,
    x2: 1182.387,
    y2: 783.467,
    id: "svg_599",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 1193.196,
    y1: 789.673,
    x2: 1204.005,
    y2: 783.467,
    id: "svg_600",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 1193.196,
    y1: 828.71,
    x2: 1182.386,
    y2: 834.917,
    id: "svg_601",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 1193.196,
    y1: 809.192,
    x2: 1164.311,
    y2: 825.779,
    id: "svg_602",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 1176.201,
    y1: 818.951,
    x2: 1176.201,
    y2: 831.366,
    id: "svg_603",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 1193.196,
    y1: 809.192,
    x2: 1222.08,
    y2: 792.605,
    id: "svg_604",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 1210.19,
    y1: 799.433,
    x2: 1210.19,
    y2: 787.019,
    id: "svg_605",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 1210.19,
    y1: 799.433,
    x2: 1221,
    y2: 805.641,
    id: "svg_606",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 1176.201,
    y1: 818.951,
    x2: 1165.392,
    y2: 812.744,
    id: "svg_607",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 1193.196,
    y1: 809.191,
    x2: 1164.311,
    y2: 792.604,
    id: "svg_608",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 1176.201,
    y1: 799.432,
    x2: 1165.392,
    y2: 805.639,
    id: "svg_609",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 7.1511,
    strokeMiterlimit: 10,
    x1: 1193.196,
    y1: 809.191,
    x2: 1222.08,
    y2: 825.778,
    id: "svg_610",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 1210.19,
    y1: 818.95,
    x2: 1220.999,
    y2: 812.743,
    id: "svg_611",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 1210.19,
    y1: 818.95,
    x2: 1210.19,
    y2: 831.365,
    id: "svg_612",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#191a19",
    strokeWidth: 6.051,
    strokeMiterlimit: 10,
    x1: 1176.201,
    y1: 799.432,
    x2: 1176.201,
    y2: 787.018,
    id: "svg_613",
    stroke: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_614",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 930.523,
    y: 631.966,
    width: 49.027,
    height: 48.764,
    id: "svg_615",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_616",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 797.893,
    y: 74.9,
    width: 49.027,
    height: 48.764,
    id: "svg_617",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_618",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 636.928,
    y: 1001.118,
    width: 49.027,
    height: 48.764,
    id: "svg_619",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_620",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1169.144,
    y: 652.518,
    width: 49.027,
    height: 48.764,
    id: "svg_621",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_622",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "652.151,862.594 662.49,840.685 672.828,862.594 695.947,866.107 679.218,883.161 683.167,907.24       662.489,895.873 641.812,907.24 645.761,883.161 629.033,866.107     ",
    id: "svg_623",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_624",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "756.885,584.877 767.224,562.968 777.563,584.877 800.682,588.39 783.953,605.444 787.902,629.524       767.224,618.157 746.546,629.524 750.496,605.444 733.768,588.391     ",
    id: "svg_625",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_626",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1185.043,403.875 1195.382,381.966 1205.72,403.875 1228.839,407.388 1212.11,424.442 1216.059,448.521       1195.381,437.154 1174.703,448.521 1178.653,424.442 1161.925,407.388     ",
    id: "svg_627",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_628",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "224.263,776.11 234.602,754.201 244.94,776.11 268.059,779.623 251.331,796.677 255.279,820.757       234.602,809.39 213.924,820.757 217.873,796.677 201.146,779.624     ",
    id: "svg_629",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_630",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_631",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m929.859,868.539l-10.49,0l0,-5.523l10.49,0l0,5.523zm4.729,-16.878l-7.404,-7.364l3.908,-3.887l7.404,7.364l-3.908,3.887zm0,28.333l3.908,3.887l-7.404,7.366l-3.906,-3.891l7.402,-7.362zm20.878,-36.925l-5.554,0l0,-10.432l5.554,0l0,10.432zm-5.555,45.517l5.554,0l0,10.43l-5.554,0c0,0 0,-10.43 0,-10.43zm20.979,-36.925l-4.011,-3.887l7.506,-7.364l3.908,3.887l-7.403,7.364zm0,28.229l7.402,7.467l-3.908,3.891l-7.402,-7.367l3.908,-3.991zm15.219,-16.875l0,5.523l-10.488,0l0,-5.523l10.488,0z",
    id: "svg_632",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#191a19",
    cx: 952.264,
    cy: 865.826,
    rx: 17.483,
    ry: 17.389,
    id: "svg_633",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_634",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_635",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m1034.776,606.372l-10.49,0l0,-5.523l10.49,0l0,5.523zm4.729,-16.877l-7.404,-7.364l3.908,-3.887l7.404,7.364l-3.908,3.887zm0,28.333l3.908,3.887l-7.404,7.366l-3.906,-3.891l7.402,-7.362zm20.877,-36.925l-5.554,0l0,-10.433l5.554,0l0,10.433zm-5.554,45.517l5.554,0l0,10.43l-5.554,0c0,0 0,-10.43 0,-10.43zm20.979,-36.925l-4.011,-3.887l7.506,-7.364l3.908,3.887l-7.403,7.364zm0,28.229l7.402,7.467l-3.908,3.891l-7.402,-7.367l3.908,-3.991zm15.219,-16.875l0,5.523l-10.488,0l0,-5.523l10.488,0z",
    id: "svg_636",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#191a19",
    cx: 1057.181,
    cy: 603.66,
    rx: 17.483,
    ry: 17.389,
    id: "svg_637",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_638",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_639",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m964.434,448.517l-10.49,0l0,-5.523l10.49,0l0,5.523zm4.729,-16.878l-7.404,-7.364l3.908,-3.887l7.404,7.364l-3.908,3.887zm0,28.334l3.908,3.887l-7.404,7.366l-3.906,-3.891l7.402,-7.362zm20.878,-36.925l-5.554,0l0,-10.432l5.554,0l0,10.432zm-5.555,45.517l5.554,0l0,10.43l-5.554,0c0,0 0,-10.43 0,-10.43zm20.979,-36.926l-4.011,-3.887l7.506,-7.364l3.908,3.887l-7.403,7.364zm0,28.229l7.402,7.467l-3.908,3.891l-7.402,-7.367l3.908,-3.991zm15.219,-16.874l0,5.523l-10.488,0l0,-5.523l10.488,0z",
    id: "svg_640",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#191a19",
    cx: 986.839,
    cy: 445.805,
    rx: 17.483,
    ry: 17.389,
    id: "svg_641",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_642",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_643",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191a19",
    d: "m1116.235,472.287l-10.49,0l0,-5.523l10.49,0l0,5.523zm4.729,-16.878l-7.404,-7.364l3.908,-3.887l7.404,7.364l-3.908,3.887zm0,28.333l3.908,3.887l-7.404,7.366l-3.906,-3.891l7.402,-7.362zm20.878,-36.925l-5.554,0l0,-10.432l5.554,0l0,10.432zm-5.554,45.517l5.554,0l0,10.43l-5.554,0c0,0.001 0,-10.43 0,-10.43zm20.978,-36.925l-4.011,-3.887l7.506,-7.364l3.908,3.887l-7.403,7.364zm0,28.229l7.402,7.467l-3.908,3.891l-7.402,-7.367l3.908,-3.991zm15.219,-16.875l0,5.523l-10.488,0l0,-5.523l10.488,0z",
    id: "svg_644",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#191a19",
    cx: 1138.64,
    cy: 469.574,
    rx: 17.483,
    ry: 17.389,
    id: "svg_645",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_646",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_647",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m590.535,275.056c0,0 0.001,10.936 0.001,24.379s-0.001,24.379 -0.001,24.379c-13.515,0 -24.51,-10.936 -24.51,-24.379c0,-13.441 10.995,-24.379 24.51,-24.379m0,-6.095c-16.922,0 -30.639,13.643 -30.639,30.475c0,16.83 13.718,30.475 30.639,30.475s30.639,-13.645 30.639,-30.475c0,-16.832 -13.718,-30.475 -30.639,-30.475l0,0z",
    id: "svg_648",
    fill: "#191a19",
    stroke: "null"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_649",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_650",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m866.841,636.333c0,0 0.001,10.937 0.001,24.379c0,13.442 -0.001,24.379 -0.001,24.379c-13.515,0 -24.51,-10.936 -24.51,-24.379c-0.001,-13.442 10.995,-24.379 24.51,-24.379m0,-6.095c-16.922,0 -30.639,13.643 -30.639,30.475c0,16.83 13.718,30.475 30.639,30.475c16.921,0 30.639,-13.645 30.639,-30.475c0,-16.832 -13.718,-30.475 -30.639,-30.475l0,0z",
    id: "svg_651",
    fill: "#191a19",
    stroke: "null"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_652",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_653",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m436.36,641.243c0,0 0.001,10.937 0.001,24.379c0,13.442 -0.001,24.379 -0.001,24.379c-13.515,0 -24.51,-10.936 -24.51,-24.379c0,-13.442 10.996,-24.379 24.51,-24.379m0,-6.096c-16.922,0 -30.639,13.643 -30.639,30.475c0,16.83 13.718,30.475 30.639,30.475c16.921,0 30.639,-13.645 30.639,-30.475c0.001,-16.831 -13.718,-30.475 -30.639,-30.475l0,0z",
    id: "svg_654",
    fill: "#191a19",
    stroke: "null"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_655",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_656",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m658.708,52.74c0,0 0.001,10.936 0.001,24.379s-0.001,24.379 -0.001,24.379c-13.515,0 -24.51,-10.936 -24.51,-24.379c0,-13.442 10.995,-24.379 24.51,-24.379m0,-6.096c-16.922,0 -30.639,13.643 -30.639,30.475c0,16.83 13.718,30.475 30.639,30.475c16.921,0 30.639,-13.645 30.639,-30.475c0,-16.831 -13.718,-30.475 -30.639,-30.475l0,0z",
    id: "svg_657",
    fill: "#191a19",
    stroke: "null"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "951,999.363 929.072,976.177 943.26,976.177 917.534,948.977 891.809,976.177 905.996,976.177 884.068,999.363      911.701,999.363 911.701,1015.48 923.367,1015.48 923.367,999.363    ",
    id: "svg_658",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.896,646.937 376.969,623.751 391.156,623.751 365.43,596.55 339.706,623.751 353.892,623.751      331.965,646.937 359.598,646.937 359.598,663.054 371.264,663.054 371.264,646.937    ",
    id: "svg_659",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.978,507.134 174.05,483.949 188.238,483.949 162.512,456.748 136.787,483.949 150.974,483.949      129.046,507.134 156.679,507.134 156.679,523.252 168.345,523.252 168.345,507.134    ",
    id: "svg_660",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1201.169,372.521 1179.241,349.335 1193.429,349.335 1167.703,322.135 1141.979,349.335 1156.165,349.335      1134.238,372.521 1161.871,372.521 1161.871,388.638 1173.537,388.638 1173.537,372.521    ",
    id: "svg_661",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_662",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "685.027,919.343 718.325,861.978 751.623,919.343     ",
    id: "svg_663",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_664",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "232.194,239.003 265.491,181.639 298.79,239.003     ",
    id: "svg_665",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_666",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "252.934,299.05 286.232,241.686 319.53,299.05     ",
    id: "svg_667",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_668",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "988.488,900.341 1021.786,842.977 1055.084,900.341     ",
    id: "svg_669",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "954.819,466.694 935.957,447.944 935.961,447.94 928.704,440.723 928.699,440.728 928.656,440.686      921.406,447.901 921.447,447.941 902.554,466.733 909.81,473.951 922.782,461.049 922.782,496.1 934.563,496.1 934.563,460.98      947.569,473.909    ",
    id: "svg_670",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.334,1184.17 367.472,1165.42 367.476,1165.417 360.219,1158.199 360.213,1158.204 360.171,1158.162      352.921,1165.377 352.962,1165.417 334.068,1184.209 341.325,1191.427 354.297,1178.525 354.297,1213.576 366.078,1213.576      366.078,1178.456 379.084,1191.385    ",
    id: "svg_671",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.252,546.398 202.391,527.648 202.394,527.645 195.137,520.427 195.132,520.432 195.089,520.39      187.84,527.605 187.88,527.645 168.987,546.437 176.243,553.655 189.215,540.753 189.215,575.804 200.997,575.804      200.997,540.684 214.003,553.613    ",
    id: "svg_672",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1105.68,723.666 1086.819,704.916 1086.822,704.912 1079.565,697.695 1079.56,697.7 1079.517,697.658      1072.268,704.873 1072.308,704.913 1053.415,723.705 1060.672,730.922 1073.643,718.02 1073.643,753.072 1085.425,753.072      1085.425,717.952 1098.431,730.88    ",
    id: "svg_673",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_674",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "668.433,279.734 680.124,268.106 680.124,293.062 690.74,293.062 690.74,268.034 702.472,279.697       709.002,273.192 692,256.293 692.003,256.29 685.463,249.782 685.456,249.789 685.423,249.757 678.89,256.253 678.924,256.287       661.893,273.229     ",
    id: "svg_675",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "706.062,286.649 706.062,303.827 664.278,303.827 664.278,286.649 654.807,286.649 654.807,313.248       664.278,313.248 664.278,313.248 706.062,313.248 706.062,313.248 715.534,313.248 715.534,286.649     ",
    id: "svg_676",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_677",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "406.855,1016.215 418.546,1004.586 418.546,1029.542 429.162,1029.542 429.162,1004.515 440.894,1016.178       447.424,1009.672 430.422,992.774 430.425,992.77 423.885,986.262 423.877,986.27 423.845,986.238 417.312,992.734       417.346,992.768 400.315,1009.709     ",
    id: "svg_678",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.484,1023.13 444.484,1040.308 402.7,1040.308 402.7,1023.13 393.229,1023.13 393.229,1049.729       402.7,1049.729 402.7,1049.728 444.484,1049.728 444.484,1049.729 453.955,1049.729 453.955,1023.13     ",
    id: "svg_679",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_680",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "67.879,482.908 79.57,471.279 79.57,496.235 90.186,496.235 90.186,471.207 101.918,482.87 108.448,476.365       91.446,459.466 91.449,459.463 84.909,452.955 84.901,452.962 84.869,452.93 78.336,459.426 78.37,459.46 61.339,476.402           ",
    id: "svg_681",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.508,489.823 105.508,507 63.724,507 63.724,489.823 54.253,489.823 54.253,516.421 63.724,516.421       63.724,516.421 105.508,516.421 105.508,516.421 114.979,516.421 114.979,489.823     ",
    id: "svg_682",
    fill: "#191a19",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_683",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "633.33,148.052 645.021,136.423 645.021,161.38 655.637,161.38 655.637,136.352 667.369,148.015       673.899,141.509 656.897,124.611 656.9,124.607 650.359,118.1 650.352,118.107 650.32,118.075 643.786,124.571 643.82,124.605       626.79,141.546     ",
    id: "svg_684",
    fill: "#191a19",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.959,154.967 670.959,172.145 629.175,172.145 629.175,154.967 619.703,154.967 619.703,181.566       629.175,181.566 629.175,181.565 670.959,181.565 670.959,181.566 680.43,181.566 680.43,154.967     ",
    id: "svg_685",
    fill: "#191a19",
    stroke: "null"
  }))))), /*#__PURE__*/React.createElement("text", {
    fillOpacity: 0.85,
    fill: "#191a19",
    strokeWidth: 0,
    x: 1355.67985,
    y: 273.83987,
    id: "svg_686",
    fontSize: 250,
    fontFamily: "sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve",
    transform: "matrix(3.72499 0 0 3.73492 -3688.38 -162.466)",
    fontWeight: "bold",
    fontStyle: "normal",
    stroke: "#000"
  }, "VISUAL"), /*#__PURE__*/React.createElement("text", {
    fillOpacity: 0.85,
    fill: "#191a19",
    strokeWidth: 0,
    x: 1680.73042,
    y: 1244.92542,
    id: "svg_687",
    fontSize: 250,
    fontFamily: "sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve",
    transform: "matrix(2.0425 0 0 2.0425 -1968.01 -1038.97)",
    fontWeight: "bold",
    fontStyle: "normal",
    stroke: "#000"
  }, "PATHFINDER"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo50D5C895);
export default __webpack_public_path__ + "static/media/logo.50d5c895.50d5c8957c7623192494089e6b9a4dfb.svg";
export { ForwardRef as ReactComponent };